import {
    validationDefault,
    validationDefaultNew,
    defaultYearReport,
    defaultMonthReport,
    maxModeloVehiculo,
} from '../../components/utilities/rulesUtilities';
import genericOptions from '../defaultConfigRole/genericOptions';
import genericColumnsCalculator from '../defaultConfigRole/genericColumnsCalculator';
import requestsListStatus from './requestsListStatus';
import { objGenericUrl } from '../defaultConfigRole/genericUrls';
import { PROPERTIES, URL } from '../../constants/constantValues';
import { randomFloat } from '../../components/utilities/functions/General';
import requestsWarrantyList from './requestsWarrantyList';
import requestsFinancialSolutionsStatus from './requestsFinancialSolutionsStatus';

const Rules = {
    role_8f4f037bf18d4c548fd80acf80d30c58: {
        //Ejecutivo
        home: 'credits',
        requestsListStatus,
        requestsWarrantyList,
        requestsFinancialSolutionsStatus,
        executive: false,
        views: {
            create: {
                titleRequestCredit: 'Solicitudes de créditos',
                permisions: ['listRequestCredit', 'showActionsRequest'],
                allowedstatus: [20],
                components: [
                    { name: 'Documentos', component: ['DocumentsCreditView'] },
                    {
                        name: 'Consultas',
                        component: ['AutomaticFilters', 'ExceptionClient'],
                    },
                    {
                        name: 'Información de la solicitud',
                        component: ['InformationCredit', 'CalculatorCredit'],
                    },
                    { name: 'Codeudores', component: ['CodebtorCredit'] },
                    {
                        name: 'Inf. negocio',
                        component: ['BusinessInformationCredit'],
                    },
                    {
                        name: 'Solicitante',
                        component: ['InformationClient'],
                    },
                    {
                        name: 'Contacto solicitante',
                        component: ['ContactsClient'],
                    },
                  
                    
                    { name: 'Documentos', component: ['DocumentsCredit'] },
                ],
                actionStatus: [
                    'modalAssignUser',
                    'rechazar',
                    'resumen',
                    'anotaciones',
                    'desistir',
                    'devolver',
                    'retornar',
                ],
                actionStatusAll: ['resumen', 'anotaciones'],
                groupUser: 9,
            },
            createWarranty: {
                titleRequestCredit: 'Solicitudes de créditos',
                permisions: [
                    'listRequestCredit',
                    'viewGestionGroup',
                    'viewWarrantyCount',
                ],
                components: [
                    {
                        name: 'Cliente',
                        component: [
                            // 'InformationClient',
                            // 'ContactsClient',
                            // 'BusinessInformationCreditAlly',
                            'ClientCardsInfo',
                            'AutomaticFilters',
                        ],
                    },
                    {
                        name: 'Información del crédito',
                        component: ['FinancialState'],
                    },
                    { name: 'Documentos', component: ['DocumentsWarranty'] },
                    {
                        name: 'Inf. del Vehículo',
                        component: [
                            'InformationWarrantyVehicle',
                            'ContactsWarranty',
                        ],
                    },
                    {
                        name: 'Inf. garantía vehicular',
                        component: [
                            // 'InformationWarranty',
                            'BillsWarranty',
                            'FinancialEvaluationWarranty',
                        ],
                    },
                ],
                actionStatus: ['radicationRequest'],
                actionStatusAll: ['anotaciones'],
                notEditForm: true,
            },
            createFinancialSolutions: {
                titleRequestCredit: 'Solicitudes de créditos',
                permisions: [
                    'listRequestCredit',
                    'viewGestionGroup',
                    'viewWarrantyCount',
                ],
                components: [
                    {
                        name: 'CLiente',
                        component: ['ClientCardsInfo'],
                    },
                    {
                        name: 'Información del crédito',
                        component: ['FinancialState'],
                    },
                    {
                        name: 'Solución financiera',
                        component: ['FinancialSolutions'],
                    },
                    {
                        name: 'Documentos',
                        component: ['DocumentsFinancialSolution'],
                    },
                ],
                actionStatus: ['desistir', 'rechazar', 'anotaciones'],
                actionStatusAll: ['anotaciones'],
                notEditForm: true,
            },
            consult: {
                permisions: ['consultClientList', 'ConsultClientEdit'],
                components: [
                    {
                        name: 'Solicitante',
                        component: ['InformationClient'],
                    },
                    { name: 'Contacto', component: ['ContactsClient'] },
                    { name: 'Documentos', component: ['DocumentsClient'] },
                    {
                        name: 'Solicitudes cliente',
                        component: ['RequestsClient'],
                    },
                    { name: 'Crédito', component: ['GygClient'] },
                ],
                noShowFieldsConsult: false,
            },
            consultSolicitud: {
                permisions: ['listRequestCredit'],
                notEditForm: true,
                components: [
                    { name: 'Documentos', component: ['DocumentsCredit'] },
                    {
                        name: 'Solicitante',
                        component: ['InformationClient'],
                    },
                    {
                        name: 'Consultas',
                        component: ['AutomaticFilters', 'ExceptionClient'],
                    },
                    {
                        name: 'Vínculos',
                        component: ['ContactLinks'],
                    },
                    {
                        name: 'Registro de Visitas',
                        component: ['RecordVisitCredit'],
                    },
                    {
                        name: 'Contacto solicitante',
                        component: ['ContactsClient'],
                    },
                    {
                        name: 'Información de la solicitud',
                        component: ['InformationCredit', 'CalculatorCredit'],
                    },
                    {
                        name: 'Información del negocio',
                        component: ['BusinessInformationCredit'],
                    },
                    { name: 'Codeudores', component: ['CodebtorCredit'] },
                    {
                        name: 'Cónyuge',
                        component: ['ConyugeClient'],
                    },
                    {
                        name: 'Referencias',
                        component: ['ReferencesCredit'],
                    },
                   
                ],
                actionStatus: [
                    'modalAssignUser',
                    'rechazar',
                    'resumen',
                    'anotaciones',
                    'desistir',
                ],
                actionStatusAll: ['resumen', 'anotaciones'],
                groupUser: 9,
                componentConfigs: {
                    informationClient: {
                        permisions: [
                            'informationClient:list',
                            'informationClient:edit',
                        ],
                        // automaticFilters: true,
                        fields: [
                            {
                                name: 'tipo_identificacion',
                                label: 'Tipo identificación',
                                disabled: true,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_de_documento,
                            },
                            {
                                label: 'Número de identificación',
                                name: 'numero_identificacion',
                                disabled: true,
                                type: 'integer',
                                col: 3,
                            },
                            {
                                name: 'primer_nombre',
                                disabled: true,
                                type: 'string',
                                col: 3,
                            },
                            {
                                name: 'segundo_nombre',
                                disabled: true,
                                type: 'string',
                                col: 3,
                            },
                            {
                                name: 'primer_apellido',
                                disabled: true,
                                type: 'string',
                                col: 3,
                            },
                            {
                                name: 'segundo_apellido',
                                disabled: true,
                                type: 'string',
                                col: 3,
                            },
                            {
                                name: 'genero',
                                label: 'Género',
                                disabled: true,
                                type: 'select',
                                col: 3,
                                options: genericOptions.genero,
                            },
                            {
                                name: 'lugar_expedicion_documento',
                                label: 'Lugar expedición documento',
                                disabled: true,
                                type: 'autocomplete',
                                col: 3,
                                options: [],
                                url: URL.CIUDADES.value,
                            },
                            {
                                name: 'fecha_expedicion_documento',
                                label: 'Fecha expedición documento',
                                disabled: true,
                                type: 'date',
                                col: 3,
                            },
                            {
                                name: 'lugar_nacimiento',
                                disabled: true,
                                type: 'autocomplete',
                                col: 3,
                                options: [],
                                url: URL.CIUDADES.value,
                            },
                            {
                                name: 'fecha_nacimiento',
                                disabled: true,
                                type: 'date',
                                col: 3,
                            },
                            {
                                name: 'grupo_social',
                                disabled: true,
                                type: 'select',
                                col: 3,
                                options: genericOptions.grupo_etnico,
                            },
                        ],
                        informacion_Trabajo: [
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: true,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: 30,
                                        },
                                        { type: 'minLength', value: 3 },
                                    ],
                                    'empresa'
                                ),
                            },
                            {
                                name: 'trabajo_ciudad',
                                label: 'Ciudad de trabajo',
                                disabled: true,
                                type: 'autocomplete',
                                col: 6,
                                options: [],
                                url: URL.CIUDADES.value,
                            },
                            {
                                name: 'trabajo_direccion',
                                label: 'Dirección del trabajo',
                                disabled: true,
                                type: 'addressComplement',
                                staticCol: 12,
                            },
                            {
                                name: 'referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: true,
                                type: 'string',
                                col: 6,
                                showTable: true,
                            },
                            {
                                name: 'trabajo_antiguedad',
                                label: 'Antigüedad (meses)',
                                disabled: true,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],
                                    'antigüedad (meses)'
                                ),
                            },
                            {
                                name: 'trabajo_telefono',
                                label: 'Teléfono de la empresa',
                                disabled: true,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],
                                    'teléfono de la empresa'
                                ),
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Ingresos',
                                disabled: true,
                                type: 'price',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.INCOME.maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.INCOME.minLength,
                                        },
                                    ],
                                    'ingresos'
                                ),
                            },
                            {
                                name: 'negocio_actividad',
                                label: 'Actividad económica',
                                disabled: true,
                                type: 'autocomplete',
                                col: 3,
                                options: [],
                                url: URL.ACTIVIDAD_ECONOMICA.value,
                            },
                        ],
                    },
                    socioeconomicClient: {
                        permisions: ['socioeconomicClient:list'],
                        fields: [
                            {
                                name: 'estado_civil',
                                disabled: true,
                                type: 'select',
                                col: 2,
                                options: genericOptions.estado_civil,
                            },
        
                            {
                                name: 'tipo_vivienda',
                                disabled: true,
                                type: 'select',
                                col: 2,
                                options: genericOptions.tipo_vivienda,
                            },
                            {
                                name: 'estrato',
                                disabled: true,
                                type: 'integer',
                                col: 2,
                            },
                            {
                                name: 'ciiu',
                                label: 'Actividad económica',
                                disabled: true,
                                type: 'autocomplete',
                                col: 3,
                                options: [],
                                url: URL.ACTIVIDAD_ECONOMICA.value,
                            },
                            {
                                name: 'descripcion_actividad_economica',
                                label: 'Descripción actividad económica',
                                disabled: true,
                                type: 'string',
                                col: 3,
                            },
                            {
                                label: 'Antigüedad residencia (meses)',
                                name: 'antiguedad_residencia',
                                disabled: true,
                                type: 'integer',
                                col: 3,
                            },
                            {
                                name: 'tamano_hogar',
                                label: 'Integrantes del hogar',
                                disabled: true,
                                type: 'integer',
                                col: 2,
                            },
                            {
                                name: 'personas_a_cargo',
                                disabled: true,
                                type: 'integer',
                                col: 2,
                            },
                            {
                                name: 'numero_hijos',
                                label: 'Número hijos',
                                disabled: true,
                                type: 'integer',
                                col: 2,
                            },
                            {
                                name: 'escolaridad',
                                disabled: true,
                                type: 'select',
                                col: 3,
                                options: genericOptions.escolaridad,
                            },
                            {
                                name: 'naturaleza',
                                disabled: true,
                                type: 'hidden',
                                col: 3,
                                // validation: validationDefault(
                                //     ['required'],
                                //     'naturaleza'
                                // ),
                                options: [
                                    {
                                        value: 'I',
                                        label: 'Independiente',
                                        fields: [
                                            {
                                                name: 'tipo_de_negocio',
                                                disabled: false,
                                                type: 'string',
                                                col: 2,
                                                validation: validationDefaultNew(
                                                    [
                                                        {
                                                            type: 'required',
                                                            value: PROPERTIES
                                                                .BUSINESS_TYPE.required,
                                                        },
                                                        {
                                                            type: 'maxLength',
                                                            value: PROPERTIES
                                                                .BUSINESS_TYPE
                                                                .maxLength,
                                                        },
                                                        {
                                                            type: 'minLength',
                                                            value: PROPERTIES
                                                                .BUSINESS_TYPE
                                                                .minLength,
                                                        },
                                                    ],
                                                    'tipo de negocio'
                                                ),
                                            },
                                            {
                                                name: 'nombre_negocio',
                                                disabled: false,
                                                type: 'string',
                                                col: 2,
                                                validation: validationDefaultNew(
                                                    [
                                                        {
                                                            type: 'required',
                                                            value: true,
                                                        },
                                                        {
                                                            type: 'maxLength',
                                                            value: PROPERTIES.JOB_NAME
                                                                .maxLength,
                                                        },
                                                        {
                                                            type: 'minLength',
                                                            value: PROPERTIES.JOB_NAME
                                                                .minLength,
                                                        },
                                                    ],
                                                    'nombre negocio'
                                                ),
                                            },
                                            {
                                                name: 'experiencia',
                                                disabled: false,
                                                type: 'string',
                                                col: 2,
                                                validation: validationDefaultNew(
                                                    [
                                                        {
                                                            type: 'required',
                                                            value: PROPERTIES.EXPERIENCE
                                                                .required,
                                                        },
                                                        {
                                                            type: 'maxLength',
                                                            value: PROPERTIES.EXPERIENCE
                                                                .maxLength,
                                                        },
                                                        {
                                                            type: 'minLength',
                                                            value: PROPERTIES.EXPERIENCE
                                                                .minLength,
                                                        },
                                                    ],
                                                    'experiencia'
                                                ),
                                            },
                                            {
                                                name: 'antiguedad',
                                                label: 'Antigüedad',
                                                disabled: false,
                                                type: 'integer',
                                                col: 2,
                                                validation: validationDefaultNew(
                                                    [
                                                        {
                                                            type: 'required',
                                                            value: true,
                                                        },
                                                        {
                                                            type: 'max',
                                                            value: PROPERTIES.ANTIQUITY
                                                                .max,
                                                        },
                                                        {
                                                            type: 'min',
                                                            value: PROPERTIES.ANTIQUITY
                                                                .min,
                                                        },
                                                    ],
                                                    'antigüedad'
                                                ),
                                            },
                                            {
                                                name: 'actividad',
                                                disabled: false,
                                                type: 'string',
                                                col: 2,
                                                validation: validationDefaultNew(
                                                    [
                                                        {
                                                            type: 'required',
                                                            value: true,
                                                        },
                                                        {
                                                            type: 'maxLength',
                                                            value: PROPERTIES.ACTIVITY
                                                                .maxLength,
                                                        },
                                                        {
                                                            type: 'minLength',
                                                            value: PROPERTIES.ACTIVITY
                                                                .minLength,
                                                        },
                                                    ],
                                                    'actividad'
                                                ),
                                            },
                                            {
                                                label: 'Descripción',
                                                name: 'descripcion',
                                                disabled: false,
                                                type: 'string',
                                                col: 2,
                                                validation: validationDefaultNew(
                                                    [
                                                        {
                                                            type: 'required',
                                                            value: true,
                                                        },
                                                        {
                                                            type: 'minLength',
                                                            value: PROPERTIES
                                                                .DESCRIPTION.minLength,
                                                        },
                                                    ],
                                                    'descripción'
                                                ),
                                            },
                                            {
                                                name: 'ingresos_aproximados',
                                                disabled: false,
                                                type: 'integer',
                                                col: 2,
                                                validation: validationDefaultNew(
                                                    [{ type: 'required', value: true }],
                                                    'segundo apellido'
                                                ),
                                            },
                                            {
                                                name: 'sector_economico',
                                                label: 'Sector económico',
                                                disabled: false,
                                                type: 'string',
                                                col: 2,
                                                validation: validationDefaultNew(
                                                    [
                                                        {
                                                            type: 'required',
                                                            value: true,
                                                        },
                                                        {
                                                            type: 'maxLength',
                                                            value: PROPERTIES
                                                                .ECONOMIC_SECTOR
                                                                .maxLength,
                                                        },
                                                        {
                                                            type: 'minLength',
                                                            value: PROPERTIES
                                                                .ECONOMIC_SECTOR
                                                                .minLength,
                                                        },
                                                    ],
                                                    'sector económico'
                                                ),
                                            },
                                            {
                                                name: 'numero_de_empleados_permanentes',
                                                label: 'Número de empleados permanentes',
                                                disabled: false,
                                                type: 'integer',
                                                col: 3,
                                                validation: validationDefaultNew(
                                                    [
                                                        {
                                                            type: 'required',
                                                            value: PROPERTIES
                                                                .PERMANENT_EMPLOYES
                                                                .required,
                                                        },
                                                        {
                                                            type: 'max',
                                                            value: PROPERTIES
                                                                .PERMANENT_EMPLOYES.max,
                                                        },
                                                        {
                                                            type: 'min',
                                                            value: PROPERTIES
                                                                .PERMANENT_EMPLOYES.min,
                                                        },
                                                    ],
                                                    'número de empleados permanentes'
                                                ),
                                            },
                                            {
                                                name: 'numero_de_empleados_temporales',
                                                label: 'Número de empleados temporales',
                                                disabled: false,
                                                type: 'integer',
                                                col: 3,
                                                validation: validationDefaultNew(
                                                    [
                                                        {
                                                            type: 'required',
                                                            value: PROPERTIES
                                                                .TEMPORARY_EMPLOYES
                                                                .required,
                                                        },
                                                        {
                                                            type: 'max',
                                                            value: PROPERTIES
                                                                .TEMPORARY_EMPLOYES.max,
                                                        },
                                                        {
                                                            type: 'min',
                                                            value: PROPERTIES
                                                                .TEMPORARY_EMPLOYES.min,
                                                        },
                                                    ],
                                                    'número de empleados temporales'
                                                ),
                                            },
                                            {
                                                name: 'tipo_local',
                                                disabled: false,
                                                type: 'string',
                                                col: 2,
                                                validation: validationDefaultNew(
                                                    [{ type: 'required', value: true }],
                                                    'tipo de local'
                                                ),
                                            },
                                        ],
                                    },
                                    // {
                                    // 	value: "E",
                                    // 	label: "Empleado",
                                    // 	fields: [{
                                    // 			name: "nombre_empresa",
                                    // 			disabled: false,
                                    // 			type: "string",
                                    // 			col: 2
                                    // 		},
                                    // 		{
                                    // 			name: "ingresos",
                                    // 			disabled: false,
                                    // 			type: "string",
                                    // 			col: 2
                                    // 		},
                                    // 		{
                                    // 			name: "actividad_economica",
                                    // 			disabled: false,
                                    // 			type: "string",
                                    // 			col: 2
                                    // 		},
                                    // 		{
                                    // 			name: "cargo",
                                    // 			disabled: false,
                                    // 			type: "string",
                                    // 			col: 2
                                    // 		},
                                    // 		{
                                    // 			name: "antiguedad",
                                    // 			disabled: false,
                                    // 			type: "string",
                                    // 			col: 2
                                    // 		},
                                    // 		{
                                    // 			name: "tipo_contrato",
                                    // 			disabled: false,
                                    // 			type: "string",
                                    // 			col: 2
                                    // 		},
                                    // 	]
                                    // },
                                    // {
                                    // 	value: "J",
                                    // 	label: "Jubilado",
                                    // 	fields: [{
                                    // 			name: "nombre_empresa",
                                    // 			disabled: false,
                                    // 			type: "string",
                                    // 			col: 2
                                    // 		},
                                    // 		{
                                    // 			name: "ingresos",
                                    // 			disabled: false,
                                    // 			type: "string",
                                    // 			col: 2
                                    // 		},
                                    // 	]
                                    // },
                                ],
                                isMulti: false,
                            },
                        ],
                    },
                    contactsClient: {
                        permisions: ['contactsClient:list'],
                        tittle: 'solicitante',
                        fields: [
                            {
                                name: 'ciudad_contacto',
                                label: 'Ciudad',
                                disabled: false,
                                type: 'autocomplete-dependency',
                                col: 6,
                                showTable: true,
                                options: [],
                                parentDependency: true,
                                childrenDependency: 'barrio_contacto',
                                url: URL.CIUDADES.value,
                                validation: validationDefault(
                                    ['required'],
                                    'ciudad de contacto'
                                ),
                            },
                            {
                                name: 'barrio_contacto',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                showTable: true,
                                dependency: 'ciudad_contacto',
                                options: [],
                                url: URL.BARRIOS.value,
                                validation: validationDefault(
                                    ['required'],
                                    'barrio de contacto'
                                ),
                            },
                            {
                                name: 'direccion',
                                label: 'Dirección',
                                disabled: true,
                                type: 'addressComplement',
                                staticCol: 12,
                                showTable: true,
                            },
                            {
                                name: 'referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: true,
                                type: 'string',
                                col: 6,
                                showTable: true,
                            },
                            {
                                name: 'telefono',
                                label: 'Teléfono',
                                disabled: true,
                                type: 'phone',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],
                                    'teléfono'
                                ),
                            },
                            {
                                name: 'celular',
                                label: 'Celular',
                                disabled: true,
                                type: 'celular',
                                col: 6,
                                showTable: true,
                            },
                            {
                                name: 'correo_electronico',
                                label: 'Correo electrónico',
                                disabled: true,
                                type: 'email',
                                col: 6,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.EMAIL.regExp,
                                            mesagge:
                                                'El correo electrónico ingresado no es válido',
                                        },
                                    ],
                                    'correo electrónico'
                                ),
                            },
                            {
                                name: 'principal',
                                label: 'Principal',
                                disabled: true,
                                type: 'select',
                                options: genericOptions.direccion_principal,
                                col: 6,
                                showTable: true,
                            },
                        ],
                        defaultValues: {
                            direccion: 'carrera 1 calle 1 # 1',
                            barrio: 'Ciudad modelo',
                            latitud: '11111324',
                            longitud: '38947239',
                            telefono: '',
                            celular: '',
                            correo_electronico: 'test@finamiga.co',
                            referencia_ubicacion: 'cerca a... diagonal a...',
                            tipo_ubicacion: 1,
                            departamento: 5,
                            ciudad_contacto: 1205,
                        },
                    },
                    informationCredit: {
                        permisions: ['informationCredit:list'],
                        fields: [
                            {
                                name: 'subproducto',
                                disabled: true,
                                type: 'select',
                                col: 4,
                                options: [],
                                parentDependency: true,
                                url: URL.SUBPRODUCTO.value,
                            },
                            {
                                name: 'oficina',
                                disabled: true,
                                type: 'select',
                                col: 4,
                                options: [],
                                parentDependency: true,
                                childrenDependency: 'ejecutivo',
                                url: URL.OFICINAS.value,
                            },
                            {
                                name: 'origen',
                                disabled: true,
                                type: 'select',
                                col: 4,
                                url: URL.ORIGEN.value,
                            },
                            {
                                name: 'medio',
                                disabled: true,
                                type: 'select',
                                col: 4,
                                url: URL.MEDIO.value,
                            },
                            {
                                name: 'aliado',
                                disabled: true,
                                type: 'string',
                                col: 4,
                            },
                            {
                                name: 'numero_aliado',
                                label: 'Número aliado',
                                disabled: true,
                                type: 'string',
                                col: 4,
                            },
                            {
                                name: 'tipo_credito',
                                label: 'Tipo crédito',
                                disabled: true,
                                type: 'select',
                                col: 4,
                                options: genericOptions.tipo_credito,
                            },
                            // {
                            //     label: 'Seguro SBS',
                            //     name: 'tipo_seguro',
                            //     disabled: true,
                            //     type: 'select',
                            //     col: 4,
                            //     options: genericOptions.tipo_seguro_sbs,
                            // },
                        ],
                        fieldsDynamic: [],
                        defaultValues: {
                            oficina: 9,
                            producto: 17,
                            origen: 1,
                            medio: 1,
                            tipo_credito: 1,
                            monto_solicitado: 5000000,
                            plazo_solicitado: 2,
                            cuota_inicial_solicitada: 1500000,
                            asesor: 'asesor test',
                            telefono_asesor: '123456798',
                            concesionario: 'concesionario test',
                            marca: 'Bajaj',
                            linea: 'Pulsar',
                            valor: 8000000,
                            soat: 480000,
                            impuestos: 120000,
                            matricula: 200000,
                            nombre_concesionario: 'concesionario test!',
                            tipo_motocicleta: 'motocicleta',
                        },
                    },
                    productCredit: {
                        permisions: ['productCredit:list'],
                        fields: [],
                        filedsConditional: {
                            p2: [
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'concesionario',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                },
                                {
                                    name: 'marca',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                },
                                {
                                    name: 'valor',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'soat',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'impuestos',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p3: [
                                // Prestamiga
                                {
                                    name: 'destino_recursos',
                                    disabled: true,
                                    type: 'string',
                                    col: 4,
                                },
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: true,
                                    type: 'autocomplete-dependency',
                                    col: 4,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    allSubChildrenDependencies: [
                                        'aliado_concesionario',
                                    ],
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'concesionario',
                                    disabled: true,
                                    type: 'select',
                                    col: 4,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                    childrenDependency: 'aliado_concesionario',
                                },
                                {
                                    name: 'aliado_concesionario',
                                    label: 'Aliado',
                                    disabled: true,
                                    type: 'select',
                                    col: 4,
                                    url: URL.ALIADOS.value,
                                    dependency: 'concesionario',
                                    trueDependency: 'concesionarios',
                                    notSearchGlobals: true,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 4,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 4,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                            ],
                            p8: [
                                // Prestamiga Preferencial
                                {
                                    name: 'destino_recursos',
                                    disabled: true,
                                    type: 'string',
                                    col: 4,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 4,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 4,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                            ],
                            p10: [
                                // Prestamiga Renovacion
                                {
                                    name: 'destino_recursos',
                                    disabled: true,
                                    type: 'string',
                                    col: 4,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 4,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 4,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                            ],
                            p18: [
                                // Prestamiga Reactivacion
                                {
                                    name: 'destino_recursos',
                                    disabled: true,
                                    type: 'string',
                                    col: 4,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 4,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 4,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                            ],
                            p6: [
                                // Cultiva
                                {
                                    name: 'destino_recursos',
                                    disabled: true,
                                    type: 'string',
                                    col: 3,
                                },
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'concesionario',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p12: [
                                // Cultiva renovacion
                                {
                                    name: 'destino_recursos',
                                    disabled: true,
                                    type: 'string',
                                    col: 3,
                                },
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'concesionario',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p14: [
                                // Cultiva preferencial
                                {
                                    name: 'destino_recursos',
                                    disabled: true,
                                    type: 'string',
                                    col: 3,
                                },
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'concesionario',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p17: [
                                // Vehiculos
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'concesionario',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                },
                                {
                                    name: 'marca',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo de vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                },
                                {
                                    name: 'seguro_todo_riesgo_vehiculo',
                                    label: 'Seguro todo riesgo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                                    validation: validationDefault(
                                        ['required'],
                                        'Seguro todo riesgo'
                                    ),
                                },
                                {
                                    name: 'valor',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'soat',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'impuestos',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                                {
                                    name: 'tipo_conductor_vehiculo',
                                    label: 'Tipo conductor del vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    url: '/globals/tipo_conductor_externo_vehiculo/',
                                    validation: validationDefault(
                                        ['required'],
                                        'Tipo conductor del vehículo'
                                    ),
                                },
                                {
                                    name: 'subrogacion',
                                    label: 'Subrogación',
                                    disabled: true,
                                    type: 'switch',
                                    typeColumn: 2,
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'subrogacion'
                                    ),
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p40: [
                                // Vehiculos usados
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'concesionario',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                },
                                {
                                    name: 'marca',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                },
                                {
                                    name: 'modelo_vehiculo',
                                    label: 'Modelo vehículo',
                                    disabled: true,
                                    type: 'integer',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            { type: 'required', value: true },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.VEHICLE_MODEL
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.VEHICLE_MODEL
                                                    .minLength,
                                            },
                                            {
                                                type: 'max',
                                                value: maxModeloVehiculo(),
                                            },
                                            {
                                                type: 'min',
                                                value: PROPERTIES.VEHICLE_MODEL.min,
                                            },
                                        ],
                                        'modelo'
                                    ),
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo de vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                },
                                {
                                    name: 'seguro_todo_riesgo_vehiculo',
                                    label: 'Seguro todo riesgo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                                    validation: validationDefault(
                                        ['required'],
                                        'Seguro todo riesgo'
                                    ),
                                },
                                {
                                    name: 'valor',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'soat',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'impuestos',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                                {
                                    name: 'valor_fasecolda',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'tipo_conductor_vehiculo',
                                    label: 'Tipo conductor del vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    url: '/globals/tipo_conductor_externo_vehiculo/',
                                    validation: validationDefault(
                                        ['required'],
                                        'Tipo conductor del vehículo'
                                    ),
                                },
                                {
                                    name: 'subrogacion',
                                    label: 'Subrogación',
                                    disabled: true,
                                    type: 'switch',
                                    typeColumn: 2,
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'subrogacion'
                                    ),
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p41: [
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'concesionario',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                },
                                {
                                    name: 'marca',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                },
                                {
                                    name: 'valor',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'soat',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'impuestos',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p42: [
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'concesionario',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                },
                                {
                                    name: 'marca',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                },
                                {
                                    name: 'valor',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'soat',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'impuestos',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p43: [
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'concesionario',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                },
                                {
                                    name: 'marca',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                },
                                {
                                    name: 'valor',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'soat',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'impuestos',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p47: [
                                // Vehiculos renovacion
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    allSubChildrenDependencies: [
                                        'aliado_concesionario',
                                    ],
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'ciudad concesionario'
                                    ),
                                },
                                {
                                    name: 'concesionario',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                    childrenDependency: 'aliado_concesionario',
                                    validation: validationDefault(
                                        ['required'],
                                        'concesionario'
                                    ),
                                },
                                {
                                    name: 'aliado_concesionario',
                                    label: 'Aliado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    url: '/globals/users/?groups=11&is_active=true',
                                    dependency: 'concesionario',
                                    trueDependency: 'concesionarios',
                                    notSearchGlobals: true,
                                    validation: validationDefault(
                                        ['required'],
                                        'Aliado'
                                    ),
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo de vehículo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'Tipo de vehículo'
                                    ),
                                },
                                {
                                    name: 'seguro_todo_riesgo_vehiculo',
                                    label: 'Seguro todo riesgo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                                    validation: validationDefault(
                                        ['required'],
                                        'Seguro todo riesgo'
                                    ),
                                },
                                {
                                    name: 'marca',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'marca'
                                    ),
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'linea'
                                    ),
                                },
                                {
                                    name: 'valor',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'valor'
                                    ),
                                },
                                {
                                    name: 'soat',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(['required'], 'soat'),
                                },
                                {
                                    name: 'impuestos',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'impuestos'
                                    ),
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'matricula'
                                    ),
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'cuota inicial solicitada'
                                    ),
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'monto solicitado'
                                    ),
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'plazo solicitado'
                                    ),
                                },
                                {
                                    name: 'tipo_conductor_vehiculo',
                                    label: 'Tipo conductor del vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    url: '/globals/tipo_conductor_externo_vehiculo/',
                                    validation: validationDefault(
                                        ['required'],
                                        'Tipo conductor del vehículo'
                                    ),
                                },
                                {
                                    name: 'subrogacion',
                                    label: 'Subrogación',
                                    disabled: true,
                                    type: 'switch',
                                    typeColumn: 2,
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'subrogacion'
                                    ),
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p113: [
                                // Carga2.0
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    allSubChildrenDependencies: [
                                        'aliado_concesionario',
                                    ],
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'ciudad concesionario'
                                    ),
                                },
                                {
                                    name: 'concesionario',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                    childrenDependency: 'aliado_concesionario',
                                    validation: validationDefault(
                                        ['required'],
                                        'concesionario'
                                    ),
                                },
                                {
                                    name: 'aliado_concesionario',
                                    label: 'Aliado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    url: URL.ALIADOS.value,
                                    dependency: 'concesionario',
                                    trueDependency: 'concesionarios',
                                    notSearchGlobals: true,
                                    validation: validationDefault(
                                        ['required'],
                                        'Aliado'
                                    ),
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo de vehículo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'tipo de vehículo'
                                    ),
                                },
                                {
                                    name: 'seguro_todo_riesgo_vehiculo',
                                    label: 'Seguro todo riesgo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                                    validation: validationDefault(
                                        ['required'],
                                        'Seguro todo riesgo'
                                    ),
                                },
                                {
                                    name: 'marca',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'marca'
                                    ),
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'linea'
                                    ),
                                },
                                {
                                    name: 'valor',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'valor'
                                    ),
                                },
                                {
                                    name: 'soat',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(['required'], 'soat'),
                                },
                                {
                                    name: 'impuestos',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'impuestos'
                                    ),
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'matricula'
                                    ),
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'cuota inicial solicitada'
                                    ),
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'monto solicitado'
                                    ),
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'plazo solicitado'
                                    ),
                                },
                                {
                                    name: 'tipo_conductor_vehiculo',
                                    label: 'Tipo conductor del vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    url: '/globals/tipo_conductor_externo_vehiculo/',
                                    validation: validationDefault(
                                        ['required'],
                                        'Tipo conductor del vehículo'
                                    ),
                                },
                                {
                                    name: 'subrogacion',
                                    label: 'Subrogación',
                                    disabled: true,
                                    type: 'switch',
                                    typeColumn: 2,
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'subrogacion'
                                    ),
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p114: [
                                // CARGA_ESPECIALES
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    allSubChildrenDependencies: [
                                        'aliado_concesionario',
                                    ],
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'ciudad concesionario'
                                    ),
                                },
                                {
                                    name: 'concesionario',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                    childrenDependency: 'aliado_concesionario',
                                    validation: validationDefault(
                                        ['required'],
                                        'concesionario'
                                    ),
                                },
                                {
                                    name: 'aliado_concesionario',
                                    label: 'Aliado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    url: URL.ALIADOS.value,
                                    dependency: 'concesionario',
                                    trueDependency: 'concesionarios',
                                    notSearchGlobals: true,
                                    validation: validationDefault(
                                        ['required'],
                                        'Aliado'
                                    ),
                                },
                                {
                                    name: 'marca',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'marca'
                                    ),
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'linea'
                                    ),
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo de vehículo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'tipo de vehículo'
                                    ),
                                },
                                {
                                    name: 'seguro_todo_riesgo_vehiculo',
                                    label: 'Seguro todo riesgo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                                    validation: validationDefault(
                                        ['required'],
                                        'Seguro todo riesgo'
                                    ),
                                },
                                {
                                    name: 'valor',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'valor'
                                    ),
                                },
                                {
                                    name: 'valor_maquinaria',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'valor maquinaria'
                                    ),
                                },
                                {
                                    name: 'soat',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(['required'], 'soat'),
                                },
                                {
                                    name: 'impuestos',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'impuestos'
                                    ),
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'matricula'
                                    ),
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'cuota inicial solicitada'
                                    ),
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'monto solicitado'
                                    ),
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'plazo solicitado'
                                    ),
                                },
        
                                {
                                    name: 'numero_aliado',
                                    label: 'Número aliado',
                                    disabled: true,
                                    type: 'string',
                                    col: 6,
                                },
                                {
                                    name: 'tipo_conductor_vehiculo',
                                    label: 'Tipo conductor del vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    url: '/globals/tipo_conductor_externo_vehiculo/',
                                    validation: validationDefault(
                                        ['required'],
                                        'Tipo conductor del vehículo'
                                    ),
                                },
                                {
                                    name: 'subrogacion',
                                    label: 'Subrogación',
                                    disabled: true,
                                    type: 'switch',
                                    typeColumn: 2,
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'subrogacion'
                                    ),
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p115: [
                                // carga pasajeros
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    allSubChildrenDependencies: [
                                        'aliado_concesionario',
                                    ],
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'ciudad concesionario'
                                    ),
                                },
                                {
                                    name: 'concesionario',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                    childrenDependency: 'aliado_concesionario',
                                    validation: validationDefault(
                                        ['required'],
                                        'concesionario'
                                    ),
                                },
                                {
                                    name: 'aliado_concesionario',
                                    label: 'Aliado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    url: URL.ALIADOS.value,
                                    dependency: 'concesionario',
                                    trueDependency: 'concesionarios',
                                    notSearchGlobals: true,
                                    validation: validationDefault(
                                        ['required'],
                                        'Aliado'
                                    ),
                                },
        
                                {
                                    name: 'marca',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'marca'
                                    ),
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'linea'
                                    ),
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo de vehículo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'tipo de vehículo'
                                    ),
                                },
                                {
                                    name: 'seguro_todo_riesgo_vehiculo',
                                    label: 'Seguro todo riesgo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                                    validation: validationDefault(
                                        ['required'],
                                        'Seguro todo riesgo'
                                    ),
                                },
                                {
                                    name: 'valor',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'valor'
                                    ),
                                },
                                {
                                    name: 'soat',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(['required'], 'soat'),
                                },
                                {
                                    name: 'impuestos',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'impuestos'
                                    ),
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'matricula'
                                    ),
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'cuota inicial solicitada'
                                    ),
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'monto solicitado'
                                    ),
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'plazo solicitado'
                                    ),
                                },
        
                                {
                                    name: 'numero_aliado',
                                    label: 'Número aliado',
                                    disabled: true,
                                    type: 'string',
                                    col: 6,
                                },
                                {
                                    name: 'tipo_conductor_vehiculo',
                                    label: 'Tipo conductor del vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    url: '/globals/tipo_conductor_externo_vehiculo/',
                                    validation: validationDefault(
                                        ['required'],
                                        'Tipo conductor del vehículo'
                                    ),
                                },
                                {
                                    name: 'subrogacion',
                                    label: 'Subrogación',
                                    disabled: true,
                                    type: 'switch',
                                    typeColumn: 2,
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'subrogacion'
                                    ),
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p117: [
                                // CARGA_ESPECIALES_2.0
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    allSubChildrenDependencies: [
                                        'aliado_concesionario',
                                    ],
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'ciudad concesionario'
                                    ),
                                },
                                {
                                    name: 'concesionario',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                    childrenDependency: 'aliado_concesionario',
                                    validation: validationDefault(
                                        ['required'],
                                        'concesionario'
                                    ),
                                },
                                {
                                    name: 'aliado_concesionario',
                                    label: 'Aliado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    url: URL.ALIADOS.value,
                                    dependency: 'concesionario',
                                    trueDependency: 'concesionarios',
                                    notSearchGlobals: true,
                                    validation: validationDefault(
                                        ['required'],
                                        'Aliado'
                                    ),
                                },
                                {
                                    name: 'marca',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'marca'
                                    ),
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'linea'
                                    ),
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo de vehículo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'tipo de vehículo'
                                    ),
                                },
                                {
                                    name: 'seguro_todo_riesgo_vehiculo',
                                    label: 'Seguro todo riesgo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                                    validation: validationDefault(
                                        ['required'],
                                        'Seguro todo riesgo'
                                    ),
                                },
                                {
                                    name: 'valor',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'valor'
                                    ),
                                },
                                {
                                    name: 'valor_maquinaria',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'valor maquinaria'
                                    ),
                                },
                                {
                                    name: 'soat',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(['required'], 'soat'),
                                },
                                {
                                    name: 'impuestos',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'impuestos'
                                    ),
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'matricula'
                                    ),
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'cuota inicial solicitada'
                                    ),
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'monto solicitado'
                                    ),
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'plazo solicitado'
                                    ),
                                },
        
                                {
                                    name: 'numero_aliado',
                                    label: 'Número aliado',
                                    disabled: true,
                                    type: 'string',
                                    col: 6,
                                },
                                {
                                    name: 'tipo_conductor_vehiculo',
                                    label: 'Tipo conductor del vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    url: '/globals/tipo_conductor_externo_vehiculo/',
                                    validation: validationDefault(
                                        ['required'],
                                        'Tipo conductor del vehículo'
                                    ),
                                },
                                {
                                    name: 'subrogacion',
                                    label: 'Subrogación',
                                    disabled: true,
                                    type: 'switch',
                                    typeColumn: 2,
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'subrogacion'
                                    ),
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p118: [
                                // carga pasajeros 2.0
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    allSubChildrenDependencies: [
                                        'aliado_concesionario',
                                    ],
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'ciudad concesionario'
                                    ),
                                },
                                {
                                    name: 'concesionario',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                    childrenDependency: 'aliado_concesionario',
                                    validation: validationDefault(
                                        ['required'],
                                        'concesionario'
                                    ),
                                },
                                {
                                    name: 'aliado_concesionario',
                                    label: 'Aliado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    url: URL.ALIADOS.value,
                                    dependency: 'concesionario',
                                    trueDependency: 'concesionarios',
                                    notSearchGlobals: true,
                                    validation: validationDefault(
                                        ['required'],
                                        'Aliado'
                                    ),
                                },
        
                                {
                                    name: 'marca',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'marca'
                                    ),
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'linea'
                                    ),
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo de vehículo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'tipo de vehículo'
                                    ),
                                },
                                {
                                    name: 'seguro_todo_riesgo_vehiculo',
                                    label: 'Seguro todo riesgo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                                    validation: validationDefault(
                                        ['required'],
                                        'Seguro todo riesgo'
                                    ),
                                },
                                {
                                    name: 'valor',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'valor'
                                    ),
                                },
                                {
                                    name: 'soat',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(['required'], 'soat'),
                                },
                                {
                                    name: 'impuestos',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'impuestos'
                                    ),
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'matricula'
                                    ),
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'cuota inicial solicitada'
                                    ),
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'monto solicitado'
                                    ),
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'plazo solicitado'
                                    ),
                                },
        
                                {
                                    name: 'numero_aliado',
                                    label: 'Número aliado',
                                    disabled: true,
                                    type: 'string',
                                    col: 6,
                                },
                                {
                                    name: 'tipo_conductor_vehiculo',
                                    label: 'Tipo conductor del vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    url: '/globals/tipo_conductor_externo_vehiculo/',
                                    validation: validationDefault(
                                        ['required'],
                                        'Tipo conductor del vehículo'
                                    ),
                                },
                                {
                                    name: 'subrogacion',
                                    label: 'Subrogación',
                                    disabled: true,
                                    type: 'switch',
                                    typeColumn: 2,
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'subrogacion'
                                    ),
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p119: [
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'concesionario',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                },
                                {
                                    name: 'marca',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                },
                                {
                                    name: 'valor',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'soat',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'impuestos',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p120: [
                                // Prestamiga_compromiso_valle
                                {
                                    name: 'destino_recursos',
                                    disabled: true,
                                    type: 'string',
                                    col: 4,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 4,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 4,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                            ],
                            p131: [
                                // MOTO RECONSTRUYE
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'concesionario',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                },
                                {
                                    name: 'marca',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                },
                                {
                                    name: 'valor',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'soat',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'impuestos',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p132: [
                                // PROGRESA RECONSTRUYE
                                // Prestamiga
                                {
                                    name: 'destino_recursos',
                                    disabled: true,
                                    type: 'string',
                                    col: 4,
                                },
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: true,
                                    type: 'autocomplete-dependency',
                                    col: 4,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    allSubChildrenDependencies: [
                                        'aliado_concesionario',
                                    ],
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'concesionario',
                                    disabled: true,
                                    type: 'select',
                                    col: 4,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                    childrenDependency: 'aliado_concesionario',
                                },
                                {
                                    name: 'aliado_concesionario',
                                    label: 'Aliado',
                                    disabled: true,
                                    type: 'select',
                                    col: 4,
                                    url: URL.ALIADOS.value,
                                    dependency: 'concesionario',
                                    trueDependency: 'concesionarios',
                                    notSearchGlobals: true,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 4,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 4,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                            ],
                            p133: [
                                // CAMPO RECONSTRUYE
                                // Cultiva
                                {
                                    name: 'destino_recursos',
                                    disabled: true,
                                    type: 'string',
                                    col: 3,
                                },
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'concesionario',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p134: [
                                // CARGA RECONSTRUYE
                                // Vehiculos
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'concesionario',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                },
                                {
                                    name: 'marca',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo de vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                },
                                {
                                    name: 'seguro_todo_riesgo_vehiculo',
                                    label: 'Seguro todo riesgo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                                    validation: validationDefault(
                                        ['required'],
                                        'Seguro todo riesgo'
                                    ),
                                },
                                {
                                    name: 'valor',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'soat',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'impuestos',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                                {
                                    name: 'tipo_conductor_vehiculo',
                                    label: 'Tipo conductor del vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    url: '/globals/tipo_conductor_externo_vehiculo/',
                                    validation: validationDefault(
                                        ['required'],
                                        'Tipo conductor del vehículo'
                                    ),
                                },
                                {
                                    name: 'subrogacion',
                                    label: 'Subrogación',
                                    disabled: true,
                                    type: 'switch',
                                    typeColumn: 2,
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'subrogacion'
                                    ),
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p135: [
                                // MOTOCARRO RECONSTRUYE
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'concesionario',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                },
                                {
                                    name: 'marca',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                },
                                {
                                    name: 'valor',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'soat',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'impuestos',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p136: [
                                // PROGRESA COMPROMISO VALLE RECONSTRUYE
                                // Prestamiga_compromiso_valle
                                {
                                    name: 'destino_recursos',
                                    disabled: true,
                                    type: 'string',
                                    col: 4,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 4,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 4,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                            ],
                            p137: [
                                // CARGA 2.0 RECONSTRUYE
                                // Carga2.0
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    allSubChildrenDependencies: [
                                        'aliado_concesionario',
                                    ],
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'ciudad concesionario'
                                    ),
                                },
                                {
                                    name: 'concesionario',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                    childrenDependency: 'aliado_concesionario',
                                    validation: validationDefault(
                                        ['required'],
                                        'concesionario'
                                    ),
                                },
                                {
                                    name: 'aliado_concesionario',
                                    label: 'Aliado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    url: URL.ALIADOS.value,
                                    dependency: 'concesionario',
                                    trueDependency: 'concesionarios',
                                    notSearchGlobals: true,
                                    validation: validationDefault(
                                        ['required'],
                                        'Aliado'
                                    ),
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo de vehículo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'tipo de vehículo'
                                    ),
                                },
                                {
                                    name: 'seguro_todo_riesgo_vehiculo',
                                    label: 'Seguro todo riesgo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                                    validation: validationDefault(
                                        ['required'],
                                        'Seguro todo riesgo'
                                    ),
                                },
                                {
                                    name: 'marca',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'marca'
                                    ),
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'linea'
                                    ),
                                },
                                {
                                    name: 'valor',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'valor'
                                    ),
                                },
                                {
                                    name: 'soat',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(['required'], 'soat'),
                                },
                                {
                                    name: 'impuestos',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'impuestos'
                                    ),
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'matricula'
                                    ),
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'cuota inicial solicitada'
                                    ),
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'monto solicitado'
                                    ),
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'plazo solicitado'
                                    ),
                                },
                                {
                                    name: 'tipo_conductor_vehiculo',
                                    label: 'Tipo conductor del vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    url: '/globals/tipo_conductor_externo_vehiculo/',
                                    validation: validationDefault(
                                        ['required'],
                                        'Tipo conductor del vehículo'
                                    ),
                                },
                                {
                                    name: 'subrogacion',
                                    label: 'Subrogación',
                                    disabled: true,
                                    type: 'switch',
                                    typeColumn: 2,
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'subrogacion'
                                    ),
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p138: [
                                // CARGA ESPECIALES RECONSTRUYE
                                // CARGA_ESPECIALES
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    allSubChildrenDependencies: [
                                        'aliado_concesionario',
                                    ],
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'ciudad concesionario'
                                    ),
                                },
                                {
                                    name: 'concesionario',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                    childrenDependency: 'aliado_concesionario',
                                    validation: validationDefault(
                                        ['required'],
                                        'concesionario'
                                    ),
                                },
                                {
                                    name: 'aliado_concesionario',
                                    label: 'Aliado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    url: URL.ALIADOS.value,
                                    dependency: 'concesionario',
                                    trueDependency: 'concesionarios',
                                    notSearchGlobals: true,
                                    validation: validationDefault(
                                        ['required'],
                                        'Aliado'
                                    ),
                                },
                                {
                                    name: 'marca',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'marca'
                                    ),
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'linea'
                                    ),
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo de vehículo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'tipo de vehículo'
                                    ),
                                },
                                {
                                    name: 'seguro_todo_riesgo_vehiculo',
                                    label: 'Seguro todo riesgo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                                    validation: validationDefault(
                                        ['required'],
                                        'Seguro todo riesgo'
                                    ),
                                },
                                {
                                    name: 'valor',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'valor'
                                    ),
                                },
                                {
                                    name: 'valor_maquinaria',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'valor maquinaria'
                                    ),
                                },
                                {
                                    name: 'soat',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(['required'], 'soat'),
                                },
                                {
                                    name: 'impuestos',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'impuestos'
                                    ),
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'matricula'
                                    ),
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'cuota inicial solicitada'
                                    ),
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'monto solicitado'
                                    ),
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'plazo solicitado'
                                    ),
                                },
        
                                {
                                    name: 'numero_aliado',
                                    label: 'Número aliado',
                                    disabled: true,
                                    type: 'string',
                                    col: 6,
                                },
                                {
                                    name: 'tipo_conductor_vehiculo',
                                    label: 'Tipo conductor del vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    url: '/globals/tipo_conductor_externo_vehiculo/',
                                    validation: validationDefault(
                                        ['required'],
                                        'Tipo conductor del vehículo'
                                    ),
                                },
                                {
                                    name: 'subrogacion',
                                    label: 'Subrogación',
                                    disabled: true,
                                    type: 'switch',
                                    typeColumn: 2,
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'subrogacion'
                                    ),
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p139: [
                                // CARGA PASAJEROS RECONSTRUYE
                                // carga pasajeros
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    allSubChildrenDependencies: [
                                        'aliado_concesionario',
                                    ],
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'ciudad concesionario'
                                    ),
                                },
                                {
                                    name: 'concesionario',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                    childrenDependency: 'aliado_concesionario',
                                    validation: validationDefault(
                                        ['required'],
                                        'concesionario'
                                    ),
                                },
                                {
                                    name: 'aliado_concesionario',
                                    label: 'Aliado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    url: URL.ALIADOS.value,
                                    dependency: 'concesionario',
                                    trueDependency: 'concesionarios',
                                    notSearchGlobals: true,
                                    validation: validationDefault(
                                        ['required'],
                                        'Aliado'
                                    ),
                                },
        
                                {
                                    name: 'marca',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'marca'
                                    ),
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'linea'
                                    ),
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo de vehículo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'tipo de vehículo'
                                    ),
                                },
                                {
                                    name: 'seguro_todo_riesgo_vehiculo',
                                    label: 'Seguro todo riesgo',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                                    validation: validationDefault(
                                        ['required'],
                                        'Seguro todo riesgo'
                                    ),
                                },
                                {
                                    name: 'valor',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'valor'
                                    ),
                                },
                                {
                                    name: 'soat',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(['required'], 'soat'),
                                },
                                {
                                    name: 'impuestos',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'impuestos'
                                    ),
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'matricula'
                                    ),
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'cuota inicial solicitada'
                                    ),
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'monto solicitado'
                                    ),
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'plazo solicitado'
                                    ),
                                },
        
                                {
                                    name: 'numero_aliado',
                                    label: 'Número aliado',
                                    disabled: true,
                                    type: 'string',
                                    col: 6,
                                },
                                {
                                    name: 'tipo_conductor_vehiculo',
                                    label: 'Tipo conductor del vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    url: '/globals/tipo_conductor_externo_vehiculo/',
                                    validation: validationDefault(
                                        ['required'],
                                        'Tipo conductor del vehículo'
                                    ),
                                },
                                {
                                    name: 'subrogacion',
                                    label: 'Subrogación',
                                    disabled: true,
                                    type: 'switch',
                                    typeColumn: 2,
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'subrogacion'
                                    ),
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                            p130: [
                                // MOTO COMPROMISO VALLE RECONSTRUYE
                                {
                                    name: 'concesionario_ciudad',
                                    label: 'Ciudad concesionario',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 3,
                                    options: [],
                                    showTable: true,
                                    parentDependency: true,
                                    childrenDependency: 'concesionario',
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'concesionario',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'concesionario_ciudad',
                                    trueDependency: 'ciudad',
                                    parentDependency: true,
                                    url: URL.CONCESIONARIOS.value,
                                },
                                {
                                    name: 'marca',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    parentDependency: true,
                                    dependency: 'producto',
                                    childrenDependency: 'linea',
                                    url: URL.MARCAS.value,
                                },
                                {
                                    name: 'linea',
                                    label: 'Línea',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'marca',
                                    url: URL.LINEA.value,
                                },
                                {
                                    name: 'tipo_vehiculo',
                                    label: 'Tipo vehículo',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    trueDependency: 'subproductos',
                                    url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                                },
                                {
                                    name: 'valor',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'soat',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'impuestos',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'matricula',
                                    label: 'Matrícula',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'cuota_inicial_solicitada',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'monto_solicitado',
                                    disabled: true,
                                    type: 'price',
                                    col: 3,
                                },
                                {
                                    name: 'plazo_solicitado',
                                    disabled: true,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    url: URL.PLAZOS_SOLICITADO.value,
                                },
                                {
                                    name: 'seguro_agro',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    dependency: 'subproducto',
                                    clear: true,
                                    url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                                },
                            ],
                        },
                    },
                    documentsCredit: {
                        permisions: ['documentsCredit:list'],
                        fields: [
                            {
                                name: 'tipo_documento',
                                disabled: true,
                                type: 'select',
                                col: 5,
                                options: genericOptions.tipo_de_adjunto,
                                showTable: true,
                            },
                            {
                                name: 'documento',
                                disabled: true,
                                type: 'file',
                                col: 5,
                            },
                        ],
                    },
                    observationCredit: {
                        permisions: [
                            'observationCredit:list',
                            'observationCredit:edit',
                        ],
                        fields: [
                            {
                                className: 'input-observacion',
                                name: 'observacion',
                                label: 'Observación',
                                disabled: false,
                                type: 'string',
                                rows: 1,
                                typeColumn: 2,
                                col: 12,
                                showTable: true,
                                staticCol: 12,
                                validation: validationDefault(
                                    ['required'],
                                    'observación'
                                ),
                            },
                        ],
                    },
                    calculatorCredit: {
                        permisions: [
                            'calculatorCredit:list',
                            'calculatorCredit:edit',
                            'calculatorCredit:simulator',
                        ],
                        summaryCredit: genericColumnsCalculator.summaryCredit,
                        monthlyValues: genericColumnsCalculator.monthlyValues,
                        defaultValues: {},
                        fields: [
                            {
                                name: 'subproducto',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                options: [],
                                parentDependency: true,
                                url: URL.SUBPRODUCTO.value,
                                validation: validationDefault(
                                    ['required'],
                                    'subproducto'
                                ),
                            },
                            {
                                name: 'seguro_voluntario',
                                disabled: true,
                                type: 'select',
                                col: 6,
                                options: genericOptions.seguro_voluntario,
                                defaultValue: {
                                    value: '0',
                                    label: 'SIN SEGURO',
                                },
                            },
                            {
                                name: 'seguro_protegidos',
                                label: 'Seguro PROTEGI2',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                clear: true,
                                url: URL.SEGURO_FAMILIA.value,
                                dependency: 'subproducto',
                            },
                            // {
                            //     label: 'Seguro SBS',
                            //     name: 'tipo_seguro',
                            //     disabled: false,
                            //     type: 'select',
                            //     col: 4,
                            //     options: genericOptions.tipo_seguro_sbs,
                            //     validation: validationDefault(
                            //         ['required'],
                            //         'seguro sbs'
                            //     ),
                            // },
                        ],
                    },
                    ReferencesCredit: {
                        fields: [
                            {
                                name: 'persona_referenciada',
                                disabled: false,
                                type: 'select',
                                col: 12,
                                shouldSendRequestConstantly: true,
                                url: objGenericUrl.personaSolicitudReferecias,
                                reduxParams: ['client.id', 'credit.id'],
                            },
                            {
                                name: 'celular',
                                disabled: false,
                                type: 'celular',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.CELL_PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.CELL_PHONE.required,
                                        },
                                    ],
                                    'celular'
                                ),
                            },
                            {
                                name: 'primer_nombre',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.FIRST_NAME.required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.FIRST_NAME.maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.FIRST_NAME.minLength,
                                        },
                                    ],
                                    'primer nombre'
                                ),
                            },
                            {
                                name: 'segundo_nombre',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.SECOND_NAME.maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.SECOND_NAME.minLength,
                                        },
                                    ],
                                    'primer nombre'
                                ),
                            },
                            {
                                name: 'primer_apellido',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.FIRST_SURNAME.required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.FIRST_SURNAME.maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.FIRST_SURNAME.minLength,
                                        },
                                    ],
                                    'primer apellido'
                                ),
                            },
                            {
                                name: 'segundo_apellido',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.SECOND_SURNAME.maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.SECOND_NAME.minLength,
                                        },
                                    ],
                                    'segundo apellido'
                                ),
                            },
                            {
                                name: 'estado_referencia',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.estado_referencia,
                            },
                            {
                                name: 'tipo_referencia',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                // options: genericOptions.tipo_referencia,
                                parentDependency: true,
                                childrenDependency: 'barrio_referencia',
                                url: '/globals/tipo_referencia/',
                                notSearchGlobals: true,
                                validation: validationDefault(
                                    ['required'],
                                    'tipo referencia'
                                ),
                            },
                            {
                                name: 'parentesco_referencia',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                dependency: 'tipo_referencia',
                                url: '/globals/parentesco_referencia/',
                                // options: genericOptions.tipo_parentesco,
                                validation: validationDefault(
                                    ['required'],
                                    'parentesco'
                                ),
                            },
                            {
                                name: 'ciudad',
                                label: 'Ciudad',
                                disabled: false,
                                type: 'autocomplete-dependency',
                                col: 6,
                                showTable: true,
                                options: [],
                                parentDependency: true,
                                childrenDependency: 'barrio_referencia',
                                url: URL.CIUDADES.value,
                            },
                            {
                                name: 'barrio_referencia',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                showTable: true,
                                dependency: 'ciudad',
                                options: [],
                                url: URL.BARRIOS.value,
                            },
                            {
                                name: 'direccion',
                                label: 'Dirección',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                showTable: true,
                            },
                            {
                                name: 'referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE.minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE.maxLength,
                                        },
                                    ],
                                    'referencia ubicación'
                                ),
                            },
                            {
                                name: 'observacion',
                                label: 'Observación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.OBSERVATION.maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.OBSERVATION.minLength,
                                        },
                                    ],
                                    'observación'
                                ),
                            },
                        ],
                        fieldsKnowsHim: [
                            {
                                name: 'antiguedad',
                                label: '¿Hace cuanto tiempo lo conoce?',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                options: genericOptions.conoce_cliente,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],
                                    'antigüedad'
                                ),
                            },
                            {
                                name: 'recomendaria',
                                label: 'Recomendaría',
                                disabled: false,
                                type: 'switch',
                                col: 6,
                                typeColumn: 2,
                            },
                            {
                                name: 'actividad_economica',
                                label: 'Actividad económica',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .ECONOMIC_ACTIVITY_DESCRIPTION
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES
                                                .ECONOMIC_ACTIVITY_DESCRIPTION
                                                .minLength,
                                        },
                                    ],
                                    'actividad económica'
                                ),
                            },
                            {
                                name: 'antiguedad_actividad_economica',
                                label: 'Antigüedad actividad económica (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 6,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],
                                    'antigüedad actividad económica'
                                ),
                            },
                            {
                                name: 'actividad_economica_adicional',
                                label: 'Actividad económica adicional',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .ECONOMIC_ACTIVITY_DESCRIPTION
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES
                                                .ECONOMIC_ACTIVITY_DESCRIPTION
                                                .minLength,
                                        },
                                    ],
                                    'actividad económica adicional'
                                ),
                            },
                            {
                                name: 'antiguedad_actividad_economica_adicional',
                                label: 'Antigüedad actividad económica adicional (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 6,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],
                                    'antigüedad actividad económica adicional'
                                ),
                            },
                        ],
                        defaultValues: {
                            primer_nombre: 'pruebas1',
                            primer_apellido: 'sistemas',
                            segundo_apellido: 'sistemas 2',
                            celular: '3249872938',
                            direccion: 'carrera 1 calle 1 # 1',
                            barrio: 'Ciudad modelo',
                            estado_referencia: 1,
                            parentesco: 0,
                            tipo_referencia: 0,
                            conoce: true,
                            recomendaria: false,
                            actividad_economica: 'venta de pollos',
                            observacion: 'ninguna',
                            antiguedad: 2,
                        },
                    },
                    BusinessInformationCredit: {
                        permisions: ['businessInformationCredit:list'],
                        fields: [
                            {
                                name: 'nombre',
                                label: 'Nombre del negocio',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME.maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME.minLength,
                                        },
                                    ],
                                    'nombre del negocio'
                                ),
                            },
                            {
                                name: 'tipo_negocio',
                                label: 'Tipo de negocio',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                            },
                            {
                                name: 'antiguedad',
                                label: 'Antigüedad de negocio (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],
                                    'antigüedad de negocio (meses)'
                                ),
                            },
                            {
                                name: 'antiguedad_local',
                                label: 'Antigüedad de negocio en local (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],
                                    'antigüedad de negocio en local'
                                ),
                            },
                            {
                                name: 'empleados_permanentes',
                                label: 'Empleados permanentes',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.PERMANENT_EMPLOYES
                                                .required,
                                        },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.PERMANENT_EMPLOYES.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.PERMANENT_EMPLOYES.min,
                                        },
                                    ],
                                    'empleados permanentes del negocio'
                                ),
                            },
                            {
                                name: 'empleados_temporales',
                                label: 'Empleados temporales',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.TEMPORARY_EMPLOYES
                                                .required,
                                        },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.TEMPORARY_EMPLOYES.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.TEMPORARY_EMPLOYES.min,
                                        },
                                    ],
                                    'empleados temporales del negocio'
                                ),
                            },
                            {
                                name: 'telefono',
                                label: 'Teléfono del negocio',
                                disabled: false,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],
                                    'teléfono del negocio'
                                ),
                            },
                            {
                                name: 'celular',
                                label: 'Celular',
                                disabled: false,
                                type: 'celular',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.CELL_PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.CELL_PHONE.required,
                                        },
                                    ],
                                    'celular'
                                ),
                            },
                            {
                                name: 'sector_economico',
                                label: 'Sector económico del negocio',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.sector_economico,
                                validation: validationDefault(
                                    ['required'],
                                    'sector económico del negocio'
                                ),
                            },
                            {
                                name: 'negocio_ciiu',
                                label: 'Actividad del negocio',
                                disabled: false,
                                type: 'autocomplete',
                                col: 6,
                                options: [],
                                url: URL.ACTIVIDAD_ECONOMICA.value,
                                validation: validationDefault(
                                    ['required'],
                                    'actividad del negocio'
                                ),
                            },
                            {
                                name: 'descripcion_actividad',
                                label: 'Descripción de la actividad del negocio',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.DESCRIPTION_ACTIVITY
                                                .required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.DESCRIPTION_ACTIVITY
                                                .maxLength,
                                        },
                                    ],
                                    'descripción de la actividad del negocio'
                                ),
                            },
                            {
                                name: 'ciudad_negocio',
                                label: 'Ciudad del negocio',
                                disabled: false,
                                type: 'autocomplete-dependency',
                                col: 6,
                                showTable: true,
                                options: [],
                                parentDependency: true,
                                childrenDependency: 'barrio_negocio',
                                url: URL.CIUDADES_POR_DEPARTAMENTO.value,
                                reduxParams: ['globals.departamentos_regional'],
                                searchSecondParam: true,
                                validation: validationDefault(
                                    ['required'],
                                    'ciudad del negocio'
                                ),
                            },
                            {
                                name: 'barrio_negocio',
                                label: 'Barrio del negocio',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                showTable: true,
                                dependency: 'ciudad_negocio',
                                options: [],
                                url: URL.BARRIOS.value,
                                validation: validationDefault(
                                    ['required'],
                                    'barrio del negocio'
                                ),
                            },
                            {
                                name: 'direccion',
                                label: 'Dirección del negocio',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                validation: validationDefault(
                                    ['required'],
                                    'dirección del negocio'
                                ),
                            },
                            {
                                name: 'referencia_ubicacion',
                                label: 'Referencia para ubicación del negocio',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE.minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE.maxLength,
                                        },
                                    ],
                                    'referencia para ubicación del negocio'
                                ),
                            },
                            {
                                name: 'tipo_local',
                                label: 'Tipo de local',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                options: genericOptions.tipo_local,
                                validation: validationDefault(
                                    ['required'],
                                    'tipo de local del negocio'
                                ),
                            },
        
                            {
                                name: 'rut',
                                label: 'RUT',
                                disabled: false,
                                type: 'checkbox',
                                col: 1,
                                typeColumn: 3,
                            },
                            {
                                name: 'camara_comercio',
                                label: 'Cámara de comercio',
                                disabled: false,
                                type: 'checkbox',
                                col: 2,
                                typeColumn: 3,
                            },
                            {
                                name: 'registra_compras',
                                label: 'Registra compras',
                                disabled: false,
                                type: 'checkbox',
                                col: 2,
                                typeColumn: 3,
                            },
                            {
                                name: 'registra_ventas',
                                label: 'Registra ventas',
                                disabled: false,
                                type: 'checkbox',
                                col: 2,
                                typeColumn: 3,
                            },
                            {
                                name: 'eps',
                                label: 'EPS',
                                disabled: false,
                                type: 'checkbox',
                                col: 1,
                                typeColumn: 3,
                            },
                            {
                                name: 'sisben',
                                label: 'SISBEN',
                                disabled: false,
                                type: 'checkbox',
                                col: 2,
                                typeColumn: 3,
                            },
                            {
                                name: 'responsable_iva',
                                label: 'Responsable de IVA',
                                disabled: false,
                                type: 'checkbox',
                                col: 2,
                                typeColumn: 3,
                            },
                        ],
                        defaultValues: {
                            tipo_negocio: 'venta de papa',
                            nombre: 'papaMania',
                            antiguedad: 8,
                            antiguedad_local: 5,
                            descripcion_actividad: 'venta de papa',
                            telefono: '7230000',
                            celular: '3164907501',
                            direccion: 'calle  8norte  13a  45',
                            barrio: 'pruebas',
                            referencia_ubicacion: 'en la esquina cruza',
                            sector_economico: 0,
                            tipo_local: 0,
                            empleados_permanentes: 1,
                            empleados_temporales: 1,
                        },
                    },
                    conyugeClient: {
                        permisions: ['conyugeClient:list'],
                        fields: [
                            {
                                name: 'Información básica',
                                desc: '',
                                fields: [
                                    {
                                        name: 'tipo_identificacion',
                                        label: 'Tipo identificación',
                                        disabled: false,
                                        type: 'select',
                                        col: 3,
                                        options: genericOptions.tipo_de_documento,
                                        validation: validationDefault(
                                            ['required'],
                                            'tipo identificación'
                                        ),
                                    },
                                    {
                                        name: 'numero_identificacion',
                                        label: 'Número de identificación',
                                        disabled: false,
                                        type: 'integer',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES.ID_NUMBER
                                                        .required,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.ID_NUMBER
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.ID_NUMBER
                                                        .minLength,
                                                },
                                            ],
                                            'número de identificación'
                                        ),
                                    },
                                    {
                                        name: 'primer_nombre',
                                        disabled: false,
                                        type: 'string',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES.FIRST_NAME
                                                        .required,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.FIRST_NAME
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.FIRST_NAME
                                                        .minLength,
                                                },
                                            ],
                                            'primer nombre'
                                        ),
                                    },
                                    {
                                        name: 'segundo_nombre',
                                        disabled: false,
                                        type: 'string',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.SECOND_NAME
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.SECOND_NAME
                                                        .minLength,
                                                },
                                            ],
                                            'segundo nombre'
                                        ),
                                    },
                                    {
                                        name: 'primer_apellido',
                                        disabled: false,
                                        type: 'string',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES.FIRST_SURNAME
                                                        .required,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.FIRST_SURNAME
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.FIRST_SURNAME
                                                        .minLength,
                                                },
                                            ],
                                            'primer apellido'
                                        ),
                                    },
                                    {
                                        name: 'segundo_apellido',
                                        disabled: false,
                                        type: 'string',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.SECOND_SURNAME
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.SECOND_NAME
                                                        .minLength,
                                                },
                                            ],
                                            'segundo apellido'
                                        ),
                                    },
                                    {
                                        name: 'genero',
                                        label: 'Género',
                                        disabled: false,
                                        type: 'select',
                                        col: 3,
                                        options: genericOptions.genero,
                                        validation: validationDefault(
                                            ['required'],
                                            'genero'
                                        ),
                                    },
                                    {
                                        name: 'lugar_nacimiento',
                                        disabled: false,
                                        type: 'autocomplete',
                                        col: 3,
                                        options: [],
                                        url: URL.CIUDADES.value,
                                        validation: validationDefault(
                                            ['required'],
                                            'lugar de nacimiento'
                                        ),
                                    },
                                    {
                                        name: 'fecha_nacimiento',
                                        disabled: false,
                                        type: 'date',
                                        col: 3,
                                        validation: validationDefault(
                                            ['required'],
                                            'fecha de nacimiento'
                                        ),
                                    },
                                    {
                                        name: 'lugar_expedicion_documento',
                                        label: 'Lugar expedición documento',
                                        disabled: false,
                                        type: 'autocomplete',
                                        col: 3,
                                        options: [],
                                        url: URL.CIUDADES.value,
                                        validation: validationDefault(
                                            ['required'],
                                            'lugar de expedición documento'
                                        ),
                                    },
                                    {
                                        name: 'fecha_expedicion_documento',
                                        label: 'Fecha expedición documento',
                                        disabled: false,
                                        type: 'date',
                                        col: 3,
                                        validation: validationDefault(
                                            ['required'],
                                            'fecha de expedición del documento'
                                        ),
                                    },
                                    {
                                        name: 'tipo_relacion',
                                        label: 'Tipo relación',
                                        disabled: true,
                                        type: 'hidden',
                                        col: 3,
                                        value: 0,
                                    },
                                ],
                            },
                            {
                                name: 'Información del trabajo',
                                desc: '',
                                fields: [
                                    {
                                        name: 'trabajo_nombre',
                                        label: 'Empresa',
                                        disabled: false,
                                        type: 'string',
                                        col: 6,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.JOB_NAME
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.JOB_NAME
                                                        .minLength,
                                                },
                                            ],
                                            'empresa'
                                        ),
                                    },
                                    {
                                        name: 'trabajo_antiguedad',
                                        label: 'Antigüedad (meses)',
                                        disabled: false,
                                        type: 'integer',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'max',
                                                    value: PROPERTIES.ANTIQUITY.max,
                                                },
                                                {
                                                    type: 'min',
                                                    value: PROPERTIES.ANTIQUITY.min,
                                                },
                                            ],
                                            'antigüedad (meses)'
                                        ),
                                    },
                                    {
                                        name: 'trabajo_telefono',
                                        label: 'Teléfono del trabajo',
                                        disabled: false,
                                        type: 'phone',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'pattern',
                                                    value: PROPERTIES.PHONE.regExp,
                                                    mesagge:
                                                        'El número ingresado no es un número válido',
                                                },
                                            ],
                                            'teléfono de la empresa'
                                        ),
                                    },
                                    {
                                        name: 'empresa_salario',
                                        label: 'Ingresos mensuales',
                                        disabled: false,
                                        type: 'price',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.INCOME.maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.INCOME.minLength,
                                                },
                                            ],
                                            'ingresos'
                                        ),
                                    },
                                    {
                                        name: 'otros_ingresos',
                                        label: 'Otros ingresos',
                                        disabled: false,
                                        type: 'price',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.INCOME.maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.INCOME.minLength,
                                                },
                                            ],
                                            'ingresos'
                                        ),
                                    },
                                    {
                                        name: 'descripcion_otros_ingresos',
                                        label: 'Descripción otros ingresos',
                                        disabled: false,
                                        type: 'string',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES
                                                        .DESCRIPTION_ACTIVITY.maxLength,
                                                },
                                            ],
                                            'descripción actividad económica'
                                        ),
                                    },
                                    {
                                        name: 'negocio_actividad',
                                        label: 'Actividad económica',
                                        disabled: false,
                                        type: 'autocomplete',
                                        col: 3,
                                        options: [],
                                        url: URL.ACTIVIDAD_ECONOMICA.value,
                                    },
                                    {
                                        name: 'trabajo_ciudad',
                                        label: 'Ciudad del trabajo',
                                        disabled: false,
                                        type: 'autocomplete-dependency',
                                        showTable: true,
                                        parentDependency: true,
                                        childrenDependency: 'trabajo_barrio',
                                        col: 6,
                                        options: [],
                                        url: URL.CIUDADES.value,
                                    },
                                    {
                                        name: 'trabajo_barrio',
                                        label: 'Barrio del trabajo',
                                        disabled: false,
                                        type: 'select',
                                        col: 6,
                                        dependency: 'trabajo_ciudad',
                                        trueDependency: 'ciudad',
                                        url: URL.BARRIOS.value,
                                    },
                                    {
                                        name: 'trabajo_direccion',
                                        label: 'Dirección del trabajo',
                                        disabled: false,
                                        type: 'addressComplement',
                                        staticCol: 12,
                                    },
                                    {
                                        name: 'trabajo_referencia_ubicacion',
                                        label: 'Referencia ubicación',
                                        disabled: false,
                                        type: 'string',
                                        col: 6,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES
                                                        .BUSINESS_LOCATION_REFERENCE
                                                        .minLength,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES
                                                        .BUSINESS_LOCATION_REFERENCE
                                                        .maxLength,
                                                },
                                            ],
                                            'referencia ubicación'
                                        ),
                                    },
                                ],
                            },
                        ],
                        defaultValues: {
                            tipo_de_documento: 'CC',
                            numero_identificacion: '123455556',
                            primer_nombre: 'test 1',
                            segundo_nombre: 'test 2',
                            primer_apellido: 'test ape1',
                            segundo_apellido: 'test ape2',
                            genero: 'H',
                            lugar_expedicion_documento: 1205,
                            fecha_expedicion_documento: '2020-08-30',
                            lugar_nacimiento: 1205,
                            fecha_nacimiento: '2020-08-30',
                            telefono_celular: '3105436525',
                            telefono_fijo: '5555555',
        
                            //info-trabajo
                            empresa: 'pruebas',
                            direccion_trabajo: 'vereda  aaaa',
                            codigo_postal: '76001',
                            descripcion_actividad_economica: 'test information',
                            antiguedad: 1,
                            telefono_empresa: '3215647',
                            ingresos: '200000',
                            actividad_economica: 'Venta de jugos',
                        },
                    },
                    filterDataTable: {
                        permisions: ['filterDataTable'],
                        fields: [
                            {
                                name: 'oficinas',
                                disabled: false,
                                type: 'select-multiple',
                                col: 3,
                                options: [],
                                parentDependency: true,
                                childrenDependency: 'ejecutivo',
                                url: `/users/{0}/oficinas/`,
                                reduxParams: ['authUser.user'],
                            },
                            {
                                name: 'ejecutivos',
                                disabled: false,
                                type: 'select-multiple',
                                col: 3,
                                //options: [],
                                dependency: 'oficinas',
                                url: URL.EJECUTIVOS.value,
                                notSearchGlobals: true,
                            },
                            {
                                name: 'created_at__gte',
                                label: 'Fecha inicial',
                                disabled: false,
                                type: 'date',
                                col: 3,
                            },
                            {
                                name: 'created_at__lte',
                                label: 'Fecha final',
                                disabled: false,
                                type: 'date',
                                col: 3,
                            },
                        ],
                    },
                    reassingUserRequest: {
                        fields: [
                            {
                                name: 'usuario',
                                label: 'Ejecutivos',
                                disabled: false,
                                type: 'select',
                                col: 12,
                                options: [],
                                dependency: 'oficinas',
                                url: URL.EJECUTIVOS.value,
                                validation: validationDefault(['required'], 'usuario'),
                                //notSearchGlobals: true,
                            },
                            {
                                name: 'tipo_cambio_responsable',
                                disabled: false,
                                type: 'hidden',
                                col: 3,
                                value: 2,
                            },
                        ],
                    },
                },
            },
            profile: {
                fields: [
                    {
                        name: 'identification_number',
                        label: 'Número de identificación',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ID_NUMBER.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ID_NUMBER.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ID_NUMBER.minLength,
                                },
                            ],
                            'número de identificación'
                        ),
                    },
                    {
                        name: 'first_name',
                        label: 'Nombres',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'nombres'
                        ),
                    },
                    {
                        name: 'last_name',
                        label: 'Apellidos',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'apellidos'
                        ),
                    },
                    {
                        name: 'phone_number',
                        label: 'Número telefónico',
                        disabled: false,
                        type: 'celular',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'número telefónico'
                        ),
                    },
                ],
            },
        },
        components: {
            informationClient: {
                permisions: [
                    'informationClient:list',
                    'informationClient:edit',
                ],
                // automaticFilters: true,
                fields: [
                    {
                        name: 'tipo_identificacion',
                        label: 'Tipo identificación',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                        validation: validationDefault(
                            ['required'],
                            'tipo identificación'
                        ),
                        testid: 'ClientTypeIdInput',
                    },
                    {
                        label: 'Número de identificación',
                        name: 'numero_identificacion',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ID_NUMBER.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ID_NUMBER.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ID_NUMBER.minLength,
                                },
                            ],
                            'número de identificación'
                        ),
                        testid: 'ClientIdInput',
                    },
                    {
                        name: 'primer_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_NAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_NAME.minLength,
                                },
                            ],
                            'primer nombre'
                        ),
                        testid: 'ClientFirsNameInput',
                    },
                    {
                        name: 'segundo_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],
                            'segundo nombre'
                        ),
                        testid: 'ClientSecondNameInput',
                    },
                    {
                        name: 'primer_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_SURNAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_SURNAME.minLength,
                                },
                            ],
                            'primer apellido'
                        ),
                        testid: 'ClientLastFirsNameInput',
                    },
                    {
                        name: 'segundo_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],
                            'segundo apellido'
                        ),
                        testid: 'ClientSecondFirsNameInput',
                    },
                    {
                        name: 'genero',
                        label: 'Género',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.genero,
                        validation: validationDefault(['required'], 'genero'),
                        testid: 'ClientGenderInput',
                    },
                    {
                        name: 'lugar_expedicion_documento',
                        label: 'Lugar expedición documento',
                        disabled: false,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'lugar de expedición documento'
                        ),
                        testid: 'ClientDocumentPlaceInput',
                    },
                    {
                        name: 'fecha_expedicion_documento',
                        label: 'Fecha expedición documento',
                        disabled: false,
                        type: 'date',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'fecha de expedición del documento'
                        ),
                        testid: 'ClientDocumentDateInput',
                    },
                    {
                        name: 'lugar_nacimiento',
                        disabled: false,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'lugar de nacimiento'
                        ),
                        testid: 'ClientBirthPlaceInput',
                    },
                    {
                        name: 'fecha_nacimiento',
                        disabled: false,
                        type: 'date',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'fecha de nacimiento'
                        ),
                        testid: 'ClientBirthDateInput',
                    },
                    {
                        name: 'grupo_social',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.grupo_etnico,
                        testid: 'ClientSocialGroupInput',
                    },
                ],
                informacion_Trabajo: [
                    {
                        name: 'trabajo_nombre',
                        label: 'Empresa',
                        disabled: true,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.JOB_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.JOB_NAME.minLength,
                                },
                            ],
                            'empresa'
                        ),
                    },
                    {
                        name: 'trabajo_ciudad',
                        label: 'Ciudad de trabajo',
                        disabled: true,
                        type: 'autocomplete',
                        col: 6,
                        options: [],
                        url: URL.CIUDADES.value,
                    },
                    {
                        name: 'trabajo_direccion',
                        label: 'Dirección del trabajo',
                        disabled: true,
                        type: 'addressComplement',
                        staticCol: 12,
                    },
                    {
                        name: 'referencia_ubicacion',
                        label: 'Referencia ubicación',
                        disabled: true,
                        type: 'string',
                        col: 6,
                        showTable: true,
                    },
                    {
                        name: 'trabajo_antiguedad',
                        label: 'Antigüedad (meses)',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],
                            'antigüedad (meses)'
                        ),
                    },
                    {
                        name: 'trabajo_telefono',
                        label: 'Teléfono de la empresa',
                        disabled: true,
                        type: 'phone',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                            ],
                            'teléfono de la empresa'
                        ),
                    },
                    {
                        name: 'empresa_salario',
                        label: 'Ingresos',
                        disabled: true,
                        type: 'price',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.INCOME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.INCOME.minLength,
                                },
                            ],
                            'ingresos'
                        ),
                    },
                    {
                        name: 'negocio_actividad',
                        label: 'Actividad económica',
                        disabled: true,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.ACTIVIDAD_ECONOMICA.value,
                    },
                ],
            },
            socioeconomicClient: {
                permisions: [
                    'socioeconomicClient:list',
                    'socioeconomicClient:edit',
                ],
                fields: [
                    {
                        name: 'estado_civil',
                        disabled: false,
                        type: 'select',
                        col: 2,
                        options: genericOptions.estado_civil,
                        validation: validationDefault(
                            ['required'],
                            'estado civil'
                        ),
                        testid: 'ClientCivilStatusInput',
                    },
                    {
                        name: 'tipo_vivienda',
                        disabled: false,
                        type: 'select',
                        col: 2,
                        options: genericOptions.tipo_vivienda,
                        defaultValue: [],
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'tipo vivienda'
                        ),
                        testid: 'ClientHomeStatusInput',
                    },
                    {
                        name: 'estrato',
                        disabled: false,
                        type: 'integer',
                        col: 2,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                { type: 'max', value: PROPERTIES.STRATUM.max },
                                { type: 'min', value: PROPERTIES.STRATUM.min },
                            ],
                            'estrato'
                        ),
                        testid: 'ClientstratumInput',
                    },
                    {
                        name: 'ciiu',
                        label: 'Actividad económica',
                        disabled: false,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.ACTIVIDAD_ECONOMICA.value,
                        validation: validationDefault(
                            ['required'],
                            'Actividad económica'
                        ),
                        testid: 'ClientActivityEconomicInput',
                    },
                    {
                        name: 'descripcion_actividad_economica',
                        label: 'Descripción actividad económica',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.DESCRIPTION_ACTIVITY
                                        .required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.DESCRIPTION_ACTIVITY
                                        .maxLength,
                                },
                            ],
                            'descripción actividad económica'
                        ),
                        testid: 'ClientDescriptionActivityEconomicInput',
                    },
                    {
                        label: 'Antigüedad residencia (meses)',
                        name: 'antiguedad_residencia',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],
                            'antigüedad residencia'
                        ),
                        testid: 'ClientResidenceAntiquityInput',
                    },
                    {
                        name: 'tamano_hogar',
                        label: 'Integrantes del hogar',
                        disabled: false,
                        type: 'integer',
                        col: 2,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'max',
                                    value: PROPERTIES.HOUSEHOLD_MEMBERS.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.HOUSEHOLD_MEMBERS.min,
                                },
                            ],
                            'Integrantes del hogar'
                        ),
                        testid: 'ClientHouseholdMembersInput',
                    },
                    {
                        name: 'personas_a_cargo',
                        disabled: false,
                        type: 'integer',
                        col: 2,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.PEOPLE_IN_CHARGE.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.PEOPLE_IN_CHARGE.min,
                                },
                            ],
                            'personas a cargo'
                        ),
                        testid: 'ClientPeopleInChargeInput',
                    },
                    {
                        name: 'numero_hijos',
                        label: 'Número hijos',
                        disabled: false,
                        type: 'integer',
                        col: 2,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.NUMBER_OF_CHILDREN.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.NUMBER_OF_CHILDREN.min,
                                },
                            ],
                            'número de hijos'
                        ),
                        testid: 'ClientNumberOfChildrenInput',
                    },
                    {
                        name: 'escolaridad',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.escolaridad,
                        validation: validationDefault(
                            ['required'],
                            'escolaridad'
                        ),
                        testid: 'ClientEducationLevelInput',
                    },
                    {
                        name: 'naturaleza',
                        disabled: true,
                        type: 'hidden',
                        col: 3,
                        // validation: validationDefault(
                        //     ['required'],
                        //     'naturaleza'
                        // ),
                        options: [
                            {
                                value: 'I',
                                label: 'Independiente',
                                fields: [
                                    {
                                        name: 'tipo_de_negocio',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES
                                                        .BUSINESS_TYPE.required,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES
                                                        .BUSINESS_TYPE
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES
                                                        .BUSINESS_TYPE
                                                        .minLength,
                                                },
                                            ],
                                            'tipo de negocio'
                                        ),
                                    },
                                    {
                                        name: 'nombre_negocio',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.JOB_NAME
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.JOB_NAME
                                                        .minLength,
                                                },
                                            ],
                                            'nombre negocio'
                                        ),
                                    },
                                    {
                                        name: 'experiencia',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES.EXPERIENCE
                                                        .required,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.EXPERIENCE
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.EXPERIENCE
                                                        .minLength,
                                                },
                                            ],
                                            'experiencia'
                                        ),
                                    },
                                    {
                                        name: 'antiguedad',
                                        label: 'Antigüedad',
                                        disabled: false,
                                        type: 'integer',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES.ANTIQUITY
                                                        .required,
                                                },
                                                {
                                                    type: 'max',
                                                    value: PROPERTIES.ANTIQUITY
                                                        .max,
                                                },
                                                {
                                                    type: 'min',
                                                    value: PROPERTIES.ANTIQUITY
                                                        .min,
                                                },
                                            ],
                                            'antigüedad'
                                        ),
                                    },
                                    {
                                        name: 'actividad',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.ACTIVITY
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.ACTIVITY
                                                        .minLength,
                                                },
                                            ],
                                            'actividad'
                                        ),
                                    },
                                    {
                                        label: 'Descripción',
                                        name: 'descripcion',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES
                                                        .DESCRIPTION.minLength,
                                                },
                                            ],
                                            'descripción'
                                        ),
                                    },
                                    {
                                        name: 'ingresos_aproximados',
                                        disabled: false,
                                        type: 'integer',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [{ type: 'required', value: true }],
                                            'segundo apellido'
                                        ),
                                    },
                                    {
                                        name: 'sector_economico',
                                        label: 'Sector económico',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES
                                                        .ECONOMIC_SECTOR
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES
                                                        .ECONOMIC_SECTOR
                                                        .minLength,
                                                },
                                            ],
                                            'sector económico'
                                        ),
                                    },
                                    {
                                        name: 'numero_de_empleados_permanentes',
                                        label: 'Número de empleados permanentes',
                                        disabled: false,
                                        type: 'integer',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES
                                                        .PERMANENT_EMPLOYES
                                                        .required,
                                                },
                                                {
                                                    type: 'max',
                                                    value: PROPERTIES
                                                        .PERMANENT_EMPLOYES.max,
                                                },
                                                {
                                                    type: 'min',
                                                    value: PROPERTIES
                                                        .PERMANENT_EMPLOYES.min,
                                                },
                                            ],
                                            'número de empleados permanentes'
                                        ),
                                    },
                                    {
                                        name: 'numero_de_empleados_temporales',
                                        label: 'Número de empleados temporales',
                                        disabled: false,
                                        type: 'integer',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES
                                                        .TEMPORARY_EMPLOYES
                                                        .required,
                                                },
                                                {
                                                    type: 'max',
                                                    value: PROPERTIES
                                                        .TEMPORARY_EMPLOYES.max,
                                                },
                                                {
                                                    type: 'min',
                                                    value: PROPERTIES
                                                        .TEMPORARY_EMPLOYES.min,
                                                },
                                            ],
                                            'número de empleados temporales'
                                        ),
                                    },
                                    {
                                        name: 'tipo_local',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [{ type: 'required', value: true }],
                                            'tipo de local'
                                        ),
                                    },
                                ],
                            },
                        ],
                        isMulti: false,
                    },
                ],
            },
            contactsClient: {
                permisions: [
                    'contactsClient:list',
                    'contactsClient:edit',
                    'contactsClient:editButton',
                ],
                tittle: 'solicitante',
                fields: [
                    {
                        name: 'ciudad_contacto',
                        label: 'Ciudad',
                        disabled: false,
                        type: 'autocomplete-dependency',
                        col: 6,
                        showTable: true,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'barrio_contacto',
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'ciudad de contacto'
                        ),
                        testid: 'ContactCityInput',
                    },
                    {
                        name: 'barrio_contacto',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        dependency: 'ciudad_contacto',
                        options: [],
                        url: URL.BARRIOS.value,
                        validation: validationDefault(
                            ['required'],
                            'barrio del contacto'
                        ),
                        testid: 'ContactNeighborhoodInput',
                    },
                    {
                        name: 'direccion',
                        label: 'Dirección',
                        disabled: false,
                        type: 'addressComplement',
                        staticCol: 12,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ADDRESS.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ADDRESS.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ADDRESS.minLength,
                                },
                            ],
                            'dirección'
                        ),
                        testid: 'ContactAddressInput',
                    },
                    {
                        name: 'referencia_ubicacion',
                        label: 'Referencia ubicación',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        showTable: true,
                        testid: 'ContactUbicationInput',
                    },
                    {
                        name: 'telefono',
                        label: 'Teléfono',
                        disabled: false,
                        type: 'phone',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                            ],
                            'teléfono'
                        ),
                        testid: 'ContactPhoneInput',
                    },
                    {
                        name: 'celular',
                        label: 'Celular',
                        disabled: false,
                        type: 'celular',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.CELL_PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                                {
                                    type: 'required',
                                    value: PROPERTIES.CELL_PHONE.required,
                                },
                            ],
                            'celular'
                        ),
                        testid: 'ContactCellphoneInput',
                    },
                    {
                        name: 'correo_electronico',
                        label: 'Correo electrónico',
                        disabled: false,
                        type: 'email',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.EMAIL.regExp,
                                    mesagge:
                                        'El correo electrónico ingresado no es válido',
                                },
                                {
                                    type: 'required',
                                    value: true,
                                },
                            ],
                            'correo electrónico'
                        ),
                        testid: 'ContactEmailInput',
                    },
                    {
                        name: 'principal',
                        label: 'Principal',
                        disabled: false,
                        type: 'select',
                        options: genericOptions.direccion_principal,
                        defaultValue: [],
                        col: 6,
                        showTable: true,
                        testid: 'ContactPrincipalInput',
                    },
                ],
                defaultValues: {
                    direccion: 'carrera 1 calle 1 # 1',
                    barrio: 'Ciudad modelo',
                    latitud: '11111324',
                    longitud: '38947239',
                    telefono: '',
                    celular: '',
                    correo_electronico: 'test@finamiga.co',
                    referencia_ubicacion: 'cerca a... diagonal a...',
                    tipo_ubicacion: 1,
                    departamento: 5,
                    ciudad_contacto: 1205,
                },
            },
            informationCredit: {
                permisions: [
                    'informationCredit:list',
                    'informationCredit:edit',
                ],
                fields: [
                    {
                        name: 'subproducto',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: [],
                        parentDependency: true,
                        url: URL.SUBPRODUCTO.value,
                        validation: validationDefault(
                            ['required'],
                            'subproducto'
                        ),
                        testid: 'SubproductInput',
                    },
                    {
                        name: 'oficina',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'ejecutivo',
                        url: URL.OFICINAS.value,
                        validation: validationDefault(['required'], 'oficina'),
                        testid: 'OfficeInput',
                    },
                    {
                        name: 'origen',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        url: URL.ORIGEN.value,
                        validation: validationDefault(['required'], 'origen'),
                        testid: 'originInput',
                    },
                    {
                        name: 'medio',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        url: URL.MEDIO.value,
                        validation: validationDefault(['required'], 'medio'),

                        testid: 'mediumInput',
                    },
                    {
                        name: 'tipo_credito',
                        label: 'Tipo crédito',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_credito,
                        validation: validationDefault(
                            ['required'],
                            'tipo de crédito'
                        ),

                        testid: 'CreditTypeInput',
                    },
                    {
                        name: 'seguro_voluntario',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.seguro_voluntario,
                        defaultValue: {
                            value: '0',
                            label: 'SIN SEGURO',
                        },
                        validation: validationDefault(
                            ['required'],
                            'seguro voluntario'
                        ),

                        testid: 'VoluntaryInsureInput',
                    },
                    {
                        name: 'seguro_protegidos',
                        label: 'Seguro PROTEGI2',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        url: URL.SEGURO_FAMILIA.value,
                        clear: true,
                        dependency: 'subproducto',

                        testid: 'ProtectedInsuranceInput',
                    },
                    // {
                    //     label: 'Seguro SBS',
                    //     name: 'tipo_seguro',
                    //     disabled: false,
                    //     type: 'select',
                    //     col: 3,
                    //     options: genericOptions.tipo_seguro_sbs,
                    //     validation: validationDefault(
                    //         ['required'],
                    //         'seguro sbs'
                    //     ),
                    // },
                ],
                fieldsDynamic: [],
                defaultValues: {
                    oficina: 9,
                    producto: 17,
                    origen: 1,
                    medio: 1,
                    tipo_credito: 1,
                    monto_solicitado: 5000000,
                    plazo_solicitado: 2,
                    cuota_inicial_solicitada: 1500000,
                    asesor: 'asesor test',
                    telefono_asesor: '123456798',
                    concesionario: 'concesionario test',
                    marca: 'Bajaj',
                    linea: 'Pulsar',
                    valor: 8000000,
                    soat: 480000,
                    impuestos: 120000,
                    matricula: 200000,
                    nombre_concesionario: 'concesionario test!',
                    tipo_motocicleta: 'motocicleta',
                },
            },
            productCredit: {
                permisions: ['productCredit:list', 'productCredit:edit'],
                fields: [],
                filedsConditional: {
                    p2: [
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'concesionario_direccion_homologada',
                            label: 'Concesionario dirección',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'ConcesionarioDireccionHomologadaInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p3: [
                        // Prestamiga
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),

                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                    ],
                    p8: [
                        // Prestamiga Preferencial
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),

                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                    ],
                    p10: [
                        // Prestamiga Renovacion
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),

                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                    ],
                    p18: [
                        // Prestamiga Reactivacion
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),

                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                    ],
                    p6: [
                        // Cultiva
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),

                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault([''], 'ciudad'),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                [''],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p12: [
                        // Cultiva renovacion
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),

                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault([''], 'ciudad'),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                [''],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p14: [
                        // Cultiva preferencial
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),

                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault([''], 'ciudad'),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                [''],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p17: [
                        // Vehiculos
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),

                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,

                            testid: 'AnalistaFinancieroConcesionarioInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),

                            testid: 'TipoConductorVehiculoInput',
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            columnsError: 'side',
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),

                            testid: 'SubrogacionInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p40: [
                        // Vehiculos usados
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                                'analista_financiero_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'modelo_vehiculo',
                            label: 'Modelo vehículo',
                            disabled: false,
                            type: 'integer',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: maxModeloVehiculo(),
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],
                                'modelo'
                            ),

                            testid: 'ModeloVehiculoInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),

                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'valor_fasecolda',
                            disabled: false,
                            type: 'price',
                            col: 3,

                            testid: 'ValorFasecoldaInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 6,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,

                            testid: 'AnalistaFinancieroConcesionarioInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 6,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),

                            testid: 'TipoConductorVehiculoInput',
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            columnsError: 'side',
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),

                            testid: 'SubrogacionInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p41: [
                        //motoamiga renovacion
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p42: [
                        //motocarro pasajeors
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p43: [
                        //motocarro carga
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p47: [
                        // Vehiculos renovacion
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),

                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,

                            testid: 'AnalistaFinancieroConcesionarioInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),

                            testid: 'TipoConductorVehiculoInput',
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            columnsError: 'side',
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),

                            testid: 'SubrogacionInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p113: [
                        // Carga2.0
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),

                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,

                            testid: 'AnalistaFinancieroConcesionarioInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),

                            testid: 'TipoConductorVehiculoInput',
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            columnsError: 'side',
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),

                            testid: 'SubrogacionInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p114: [
                        // CARGA_ESPECIALES
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),

                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'valor_maquinaria',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),

                            testid: 'ValorMaquinariaInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),

                            testid: 'TipoConductorVehiculoInput',
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            columnsError: 'side',
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),

                            testid: 'SubrogacionInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p115: [
                        // carga pasajeros
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),

                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,

                            testid: 'AnalistaFinancieroConcesionarioInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),

                            testid: 'TipoConductorVehiculoInput',
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            columnsError: 'side',
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),

                            testid: 'SubrogacionInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p117: [
                        // CARGA_ESPECIALES_2.0
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),

                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'valor_maquinaria',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),

                            testid: 'ValorMaquinariaInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,

                            testid: 'AnalistaFinancieroConcesionarioInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),

                            testid: 'TipoConductorVehiculoInput',
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            columnsError: 'side',
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),

                            testid: 'SubrogacionInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p118: [
                        // carga pasajeros
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),

                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,

                            testid: 'AnalistaFinancieroConcesionarioInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),

                            testid: 'TipoConductorVehiculoInput',
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            columnsError: 'side',
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),

                            testid: 'SubrogacionInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p119: [
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'concesionario_direccion_homologada',
                            label: 'Concesionario dirección',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'ConcesionarioDireccionHomologadaInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p120: [
                        // Prestamiga_compromiso_valle
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),

                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                    ],
                    p131: [
                        // MOTO RECONSTRUYE
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'concesionario_direccion_homologada',
                            label: 'Concesionario dirección',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'ConcesionarioDireccionHomologadaInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p132: [
                        // PROGRESA RECONSTRUYE
                        // Prestamiga
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),

                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                    ],
                    p133: [
                        // CAMPO RECONSTRUYE
                        // Cultiva
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),

                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault([''], 'ciudad'),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                [''],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p134: [
                        // CARGA RECONSTRUYE
                        // Vehiculos
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),

                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,

                            testid: 'AnalistaFinancieroConcesionarioInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),

                            testid: 'TipoConductorVehiculoInput',
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            columnsError: 'side',
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),

                            testid: 'SubrogacionInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p135: [
                        // MOTOCARRO RECONSTRUYE
                        //motocarro carga
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p136: [
                        // PROGRESA COMPROMISO VALLE RECONSTRUYE
                        // Prestamiga_compromiso_valle
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),

                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                    ],
                    p137: [
                        // CARGA 2.0 RECONSTRUYE
                        // Carga2.0
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),

                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,

                            testid: 'AnalistaFinancieroConcesionarioInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),

                            testid: 'TipoConductorVehiculoInput',
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            columnsError: 'side',
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),

                            testid: 'SubrogacionInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p138: [
                        // CARGA ESPECIALES RECONSTRUYE
                        // CARGA_ESPECIALES
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),

                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'valor_maquinaria',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),

                            testid: 'ValorMaquinariaInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),

                            testid: 'TipoConductorVehiculoInput',
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            columnsError: 'side',
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),

                            testid: 'SubrogacionInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p139: [
                        // CARGA PASAJEROS RECONSTRUYE
                        // carga pasajeros
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),

                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,

                            testid: 'AnalistaFinancieroConcesionarioInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),

                            testid: 'TipoConductorVehiculoInput',
                        },
                        {
                            name: 'subrogacion',
                            label: 'Subrogación',
                            disabled: false,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            columnsError: 'side',
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),

                            testid: 'SubrogacionInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                    p130: [
                        // MOTO COMPROMISO VALLE RECONSTRUYE
                        {
                            name: 'concesionario_ciudad',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],
                            url: URL.CIUDADES.value,

                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            childrenDependency: 'aliado_concesionario',
                            url: URL.CONCESIONARIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),

                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'concesionario_direccion_homologada',
                            label: 'Concesionario dirección',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'ConcesionarioDireccionHomologadaInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),

                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),

                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),

                            testid: 'TypeInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),

                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),

                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),

                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),

                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),

                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),

                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),

                            testid: 'TermInput',
                        },
                        {
                            name: 'aliado_concesionario',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),

                            testid: 'AllyInput',
                        },
                        {
                            name: 'numero_aliado',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,

                            testid: 'NumeroAliadoInput',
                        },
                        {
                            name: 'seguro_agro',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',

                            testid: 'AgroInsureInput',
                        },
                    ],
                },
            },
            documentsCredit: {
                permisions: ['documentsCredit:list', 'documentsCredit:edit'],
                accept: 'image/png, image/jpeg, image/jpg, application/pdf',
                fields: [
                    {
                        name: 'solicitud_tipo_documento',
                        label: 'Tipo documento',
                        disabled: false,
                        type: 'select',
                        col: 5,
                        url: '/solicitudes/tipo_documentos/?roles=9&productos={0}&is_active=true',
                        reduxParams: ['credit.subproducto.producto'],
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                        testid: 'DocumentTypeInput',
                    },
                    {
                        name: 'documento',
                        disabled: false,
                        type: 'file',
                        col: 5,
                        validation: validationDefault(
                            ['required'],
                            'documento'
                        ),
                        testid: 'DocumentFileInput',
                    },
                ],
            },
            documentsFinancialSolution: {
                generateDocuments :true,
                permisions: [
                    'documentsFinancialSolution:list',
                    'documentsFinancialSolution:edit',
                ],
                accept: 'image/png, image/jpeg, image/jpg, application/pdf',
                fields: [
                    {
                        name: 'sf_tipo_documento',
                        label: 'Tipo documento',
                        disabled: false,
                        type: 'select',
                        col: 5,
                        url: `/globals/sf_tipo_documentos/?roles=9&tipo_soluciones={0}`,
                        reduxParams: ['financialSolution.tipo_sf_id'],
                        shouldSendRequestConstantly: true,
                    },
                    {
                        name: 'documento',
                        disabled: false,
                        type: 'file',
                        col: 5,
                    },
                ],
            },
            observationCredit: {
                permisions: ['observationCredit:list'],
                fields: [
                    {
                        name: 'observacion',
                        label: 'Observación',
                        disabled: false,
                        type: 'textarea',
                        col: 12,
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'observación'
                        ),
                    },
                ],
            },
            observationFinancialSolution: {
                permisions: [
                    'observationCredit:list',
                    'observationCredit:edit',
                ],
                fields: [
                    {
                        name: 'observacion',
                        label: 'Observación',
                        disabled: false,
                        type: 'textarea',
                        col: 12,
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'observación'
                        ),
                    },
                ],
            },
            calculatorCredit: {
                permisions: [
                    'calculatorCredit:list',
                    'calculatorCredit:edit',
                    'calculatorCredit:simulator',
                ],
                summaryCredit: genericColumnsCalculator.summaryCredit,
                monthlyValues: genericColumnsCalculator.monthlyValues,
                defaultValues: {},
                fields: [
                    {
                        name: 'subproducto',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        options: [],
                        parentDependency: true,
                        url: URL.SUBPRODUCTO.value,
                        validation: validationDefault(
                            ['required'],
                            'subproducto'
                        ),
                        testid: 'SubproductInput',
                    },
                    {
                        name: 'seguro_voluntario',
                        disabled: true,
                        type: 'select',
                        col: 6,
                        options: genericOptions.seguro_voluntario,
                        defaultValue: {
                            value: '0',
                            label: 'SIN SEGURO',
                        },
                        validation: validationDefault(
                            ['required'],
                            'seguro voluntario'
                        ),
                        testid: 'VoluntaryInsuranceInput',
                    },
                    {
                        name: 'seguro_protegidos',
                        label: 'Seguro PROTEGI2',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        url: URL.SEGURO_FAMILIA.value,
                        clear: true,
                        dependency: 'subproducto',
                        testid: 'ProtectedInsuranceInput',
                    },
                    // {
                    //     label: 'Seguro SBS',
                    //     name: 'tipo_seguro',
                    //     disabled: false,
                    //     type: 'select',
                    //     col: 4,
                    //     options: genericOptions.tipo_seguro_sbs,
                    //     validation: validationDefault(
                    //         ['required'],
                    //         'seguro sbs'
                    //     ),
                    // },
                ],
            },
            ReferencesCredit: {
                fields: [
                    {
                        name: 'persona_referenciada',
                        disabled: false,
                        type: 'select',
                        col: 12,
                        shouldSendRequestConstantly: true,
                        url: objGenericUrl.personaSolicitudReferecias,
                        reduxParams: ['client.id', 'credit.id'],
                    },
                    {
                        name: 'celular',
                        disabled: false,
                        type: 'celular',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.CELL_PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                                {
                                    type: 'required',
                                    value: PROPERTIES.CELL_PHONE.required,
                                },
                            ],
                            'celular'
                        ),
                    },
                    {
                        name: 'primer_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_NAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_NAME.minLength,
                                },
                            ],
                            'primer nombre'
                        ),
                    },
                    {
                        name: 'segundo_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],
                            'primer nombre'
                        ),
                    },
                    {
                        name: 'primer_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_SURNAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_SURNAME.minLength,
                                },
                            ],
                            'primer apellido'
                        ),
                    },
                    {
                        name: 'segundo_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],
                            'segundo apellido'
                        ),
                    },
                    {
                        name: 'estado_referencia',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.estado_referencia,
                    },
                    {
                        name: 'tipo_referencia',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        // options: genericOptions.tipo_referencia,
                        parentDependency: true,
                        childrenDependency: 'barrio_referencia',
                        url: '/globals/tipo_referencia/',
                        notSearchGlobals: true,
                        validation: validationDefault(
                            ['required'],
                            'tipo referencia'
                        ),
                    },
                    {
                        name: 'parentesco_referencia',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        dependency: 'tipo_referencia',
                        url: '/globals/parentesco_referencia/',
                        // options: genericOptions.tipo_parentesco,
                        validation: validationDefault(
                            ['required'],
                            'parentesco'
                        ),
                    },
                    {
                        name: 'ciudad',
                        label: 'Ciudad',
                        disabled: false,
                        type: 'autocomplete-dependency',
                        col: 6,
                        showTable: true,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'barrio_referencia',
                        url: URL.CIUDADES.value,
                    },
                    {
                        name: 'barrio_referencia',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        dependency: 'ciudad',
                        options: [],
                        url: URL.BARRIOS.value,
                    },
                    {
                        name: 'direccion',
                        label: 'Dirección',
                        disabled: false,
                        type: 'addressComplement',
                        staticCol: 12,
                        showTable: true,
                    },
                    {
                        name: 'referencia_ubicacion',
                        label: 'Referencia ubicación',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'minLength',
                                    value: PROPERTIES
                                        .BUSINESS_LOCATION_REFERENCE.minLength,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES
                                        .BUSINESS_LOCATION_REFERENCE.maxLength,
                                },
                            ],
                            'referencia ubicación'
                        ),
                    },
                    {
                        name: 'observacion',
                        label: 'Observación',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.OBSERVATION.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.OBSERVATION.minLength,
                                },
                            ],
                            'observación'
                        ),
                    },
                ],
                fieldsKnowsHim: [
                    {
                        name: 'antiguedad',
                        label: '¿Hace cuanto tiempo lo conoce?',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        options: genericOptions.conoce_cliente,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],
                            'antigüedad'
                        ),
                    },
                    {
                        name: 'recomendaria',
                        label: 'Recomendaría',
                        disabled: false,
                        type: 'switch',
                        col: 6,
                        typeColumn: 2,
                    },
                    {
                        name: 'actividad_economica',
                        label: 'Actividad económica',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES
                                        .ECONOMIC_ACTIVITY_DESCRIPTION
                                        .maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES
                                        .ECONOMIC_ACTIVITY_DESCRIPTION
                                        .minLength,
                                },
                            ],
                            'actividad económica'
                        ),
                    },
                    {
                        name: 'antiguedad_actividad_economica',
                        label: 'Antigüedad actividad económica (meses)',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],
                            'antigüedad actividad económica'
                        ),
                    },
                    {
                        name: 'actividad_economica_adicional',
                        label: 'Actividad económica adicional',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES
                                        .ECONOMIC_ACTIVITY_DESCRIPTION
                                        .maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES
                                        .ECONOMIC_ACTIVITY_DESCRIPTION
                                        .minLength,
                                },
                            ],
                            'actividad económica adicional'
                        ),
                    },
                    {
                        name: 'antiguedad_actividad_economica_adicional',
                        label: 'Antigüedad actividad económica adicional (meses)',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],
                            'antigüedad actividad económica adicional'
                        ),
                    },
                ],
                defaultValues: {
                    primer_nombre: 'pruebas1',
                    primer_apellido: 'sistemas',
                    segundo_apellido: 'sistemas 2',
                    celular: '3249872938',
                    direccion: 'carrera 1 calle 1 # 1',
                    barrio: 'Ciudad modelo',
                    estado_referencia: 1,
                    parentesco: 0,
                    tipo_referencia: 0,
                    conoce: true,
                    recomendaria: false,
                    actividad_economica: 'venta de pollos',
                    observacion: 'ninguna',
                    antiguedad: 2,
                },
            },
            BusinessInformationCredit: {
                permisions: [
                    'businessInformationCredit:list',
                    'businessInformationCredit:edit',
                ],
                fields: [
                    {
                        name: 'nombre',
                        label: 'Nombre del negocio',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.JOB_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.JOB_NAME.minLength,
                                },
                            ],
                            'nombre del negocio'
                        ),
                        testid: 'BusinessNameInput',
                    },
                    {
                        name: 'tipo_negocio',
                        label: 'Tipo de negocio',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'Tipo de negocio'
                        ),
                        testid: 'BusineTypeInput',
                    },
                    {
                        name: 'antiguedad',
                        label: 'Antigüedad de negocio (meses)',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],
                            'antigüedad de negocio (meses)'
                        ),
                        testid: 'BusinessAntiquityInput',
                    },
                    {
                        name: 'antiguedad_local',
                        label: 'Antigüedad de negocio en local (meses)',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                { type: 'required', value: true },
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],
                            'antigüedad de negocio en local'
                        ),
                        testid: 'BusinessLocalAntiquityInput',
                    },
                    {
                        name: 'empleados_permanentes',
                        label: 'Empleados permanentes',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.PERMANENT_EMPLOYES
                                        .required,
                                },
                                {
                                    type: 'max',
                                    value: PROPERTIES.PERMANENT_EMPLOYES.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.PERMANENT_EMPLOYES.min,
                                },
                            ],
                            'empleados permanentes del negocio'
                        ),
                        testid: 'BusinessPermanentEmployeesInput',
                    },
                    {
                        name: 'empleados_temporales',
                        label: 'Empleados temporales',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.TEMPORARY_EMPLOYES
                                        .required,
                                },
                                {
                                    type: 'max',
                                    value: PROPERTIES.TEMPORARY_EMPLOYES.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.TEMPORARY_EMPLOYES.min,
                                },
                            ],
                            'empleados temporales del negocio'
                        ),
                        testid: 'BusinessTemporaryEmployeesInput',
                    },
                    {
                        name: 'telefono',
                        label: 'Teléfono del negocio',
                        disabled: false,
                        type: 'phone',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                            ],
                            'teléfono del negocio'
                        ),
                        testid: 'BusinessPhoneInput',
                    },
                    {
                        name: 'celular',
                        label: 'Celular',
                        disabled: false,
                        type: 'celular',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.CELL_PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                                {
                                    type: 'required',
                                    value: PROPERTIES.CELL_PHONE.required,
                                },
                            ],
                            'celular'
                        ),
                        testid: 'BusinessCellphoneInput',
                    },
                    {
                        name: 'sector_economico',
                        label: 'Sector económico del negocio',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.sector_economico,
                        validation: validationDefault(
                            ['required'],
                            'sector económico del negocio'
                        ),
                        testid: 'BusinessEconomicSectorInput',
                    },
                    {
                        name: 'negocio_ciiu',
                        label: 'Actividad del negocio',
                        disabled: false,
                        type: 'autocomplete',
                        col: 6,
                        options: [],
                        url: URL.ACTIVIDAD_ECONOMICA.value,
                        validation: validationDefault(
                            ['required'],
                            'actividad del negocio'
                        ),
                        testid: 'BusinessActivityInput',
                    },
                    {
                        name: 'descripcion_actividad',
                        label: 'Descripción de la actividad del negocio',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.DESCRIPTION_ACTIVITY
                                        .required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.DESCRIPTION_ACTIVITY
                                        .maxLength,
                                },
                            ],
                            'descripción de la actividad del negocio'
                        ),
                        testid: 'BusinessDescInput',
                    },
                    {
                        name: 'ciudad_negocio',
                        label: 'Ciudad del negocio',
                        disabled: false,
                        type: 'autocomplete-dependency',
                        col: 6,
                        showTable: true,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'barrio_negocio',
                        url: URL.CIUDADES_POR_DEPARTAMENTO.value,
                        reduxParams: ['globals.departamentos_regional'],
                        searchSecondParam: true,
                        validation: validationDefault(
                            ['required'],
                            'ciudad del negocio'
                        ),
                        testid: 'BusinessCityInput',
                    },
                    {
                        name: 'barrio_negocio',
                        label: 'Barrio del negocio',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        dependency: 'ciudad_negocio',
                        options: [],
                        url: URL.BARRIOS.value,
                        validation: validationDefault(
                            ['required'],
                            'barrio del negocio'
                        ),
                        testid: 'BusinessNeighborhoodInput',
                    },
                    {
                        name: 'direccion',
                        label: 'Dirección del negocio',
                        disabled: false,
                        type: 'addressComplement',
                        staticCol: 12,
                        validation: validationDefault(
                            ['required'],
                            'dirección del negocio'
                        ),
                        testid: 'BusinessAddressInput',
                    },
                    {
                        name: 'referencia_ubicacion',
                        label: 'Referencia para ubicación del negocio',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'minLength',
                                    value: PROPERTIES
                                        .BUSINESS_LOCATION_REFERENCE.minLength,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES
                                        .BUSINESS_LOCATION_REFERENCE.maxLength,
                                },
                            ],
                            'referencia para ubicación del negocio'
                        ),
                        testid: 'BusinessUbicationInput',
                    },
                    {
                        name: 'tipo_local',
                        label: 'Tipo de local',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        options: genericOptions.tipo_local,
                        validation: validationDefault(
                            ['required'],
                            'tipo de local del negocio'
                        ),
                        testid: 'BusinessLocalTypeInput',
                    },

                    {
                        name: 'rut',
                        label: 'RUT',
                        disabled: false,
                        type: 'checkbox',
                        col: 1,
                        typeColumn: 3,
                        testid: 'BusinessRutInput',
                    },
                    {
                        name: 'camara_comercio',
                        label: 'Cámara de comercio',
                        disabled: false,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                        testid: 'BusinessCommerceChamberInput',
                    },
                    {
                        name: 'registra_compras',
                        label: 'Registra compras',
                        disabled: false,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                        testid: 'BusinessPurchaseRegistryInput',
                    },
                    {
                        name: 'registra_ventas',
                        label: 'Registra ventas',
                        disabled: false,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                        testid: 'BusinessSalesRegistryInput',
                    },
                    {
                        name: 'eps',
                        label: 'EPS',
                        disabled: false,
                        type: 'checkbox',
                        col: 1,
                        typeColumn: 3,
                        testid: 'BusinessEpsInput',
                    },
                    {
                        name: 'sisben',
                        label: 'SISBEN',
                        disabled: false,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                        testid: 'BusinessSisbenInput',
                    },
                    {
                        name: 'responsable_iva',
                        label: 'Responsable de IVA',
                        disabled: false,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                        testid: 'BusinessVatResponsibleInput',
                    },
                ],
                defaultValues: {
                    tipo_negocio: 'venta de papa',
                    nombre: 'papaMania',
                    antiguedad: 8,
                    antiguedad_local: 5,
                    descripcion_actividad: 'venta de papa',
                    telefono: '7230000',
                    celular: '3164907501',
                    direccion: 'calle  8norte  13a  45',
                    barrio: 'pruebas',
                    referencia_ubicacion: 'en la esquina cruza',
                    sector_economico: 0,
                    tipo_local: 0,
                    empleados_permanentes: 1,
                    empleados_temporales: 1,
                },
            },
            conyugeClient: {
                permisions: ['conyugeClient:list'],
                fields: [
                    {
                        name: 'Información básica',
                        desc: '',
                        fields: [
                            {
                                name: 'tipo_identificacion',
                                label: 'Tipo identificación',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_de_documento,
                                validation: validationDefault(
                                    ['required'],
                                    'tipo identificación'
                                ),
                            },
                            {
                                name: 'numero_identificacion',
                                label: 'Número de identificación',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.ID_NUMBER
                                                .required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.ID_NUMBER
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.ID_NUMBER
                                                .minLength,
                                        },
                                    ],
                                    'número de identificación'
                                ),
                            },
                            {
                                name: 'primer_nombre',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.FIRST_NAME
                                                .required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.FIRST_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.FIRST_NAME
                                                .minLength,
                                        },
                                    ],
                                    'primer nombre'
                                ),
                            },
                            {
                                name: 'segundo_nombre',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.SECOND_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.SECOND_NAME
                                                .minLength,
                                        },
                                    ],
                                    'segundo nombre'
                                ),
                            },
                            {
                                name: 'primer_apellido',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.FIRST_SURNAME
                                                .required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.FIRST_SURNAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.FIRST_SURNAME
                                                .minLength,
                                        },
                                    ],
                                    'primer apellido'
                                ),
                            },
                            {
                                name: 'segundo_apellido',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.SECOND_SURNAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.SECOND_NAME
                                                .minLength,
                                        },
                                    ],
                                    'segundo apellido'
                                ),
                            },
                            {
                                name: 'genero',
                                label: 'Género',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.genero,
                                validation: validationDefault(
                                    ['required'],
                                    'genero'
                                ),
                            },
                            {
                                name: 'lugar_nacimiento',
                                disabled: false,
                                type: 'autocomplete',
                                col: 3,
                                options: [],
                                url: URL.CIUDADES.value,
                                validation: validationDefault(
                                    ['required'],
                                    'lugar de nacimiento'
                                ),
                            },
                            {
                                name: 'fecha_nacimiento',
                                disabled: false,
                                type: 'date',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'fecha de nacimiento'
                                ),
                            },
                            {
                                name: 'lugar_expedicion_documento',
                                label: 'Lugar expedición documento',
                                disabled: false,
                                type: 'autocomplete',
                                col: 3,
                                options: [],
                                url: URL.CIUDADES.value,
                                validation: validationDefault(
                                    ['required'],
                                    'lugar de expedición documento'
                                ),
                            },
                            {
                                name: 'fecha_expedicion_documento',
                                label: 'Fecha expedición documento',
                                disabled: false,
                                type: 'date',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'fecha de expedición del documento'
                                ),
                            },
                            {
                                name: 'tipo_relacion',
                                label: 'Tipo relación',
                                disabled: true,
                                type: 'hidden',
                                col: 3,
                                value: 0,
                            },
                        ],
                    },
                    {
                        name: 'Información de contacto',
                        desc: '',
                        fields: [
                            {
                                name: 'ciudad_contacto',
                                label: 'Ciudad',
                                disabled: false,
                                type: 'autocomplete-dependency',
                                col: 6,
                                showTable: true,
                                options: [],
                                parentDependency: true,
                                childrenDependency: 'barrio_contacto',
                                url: URL.CIUDADES.value,
                                validation: validationDefault(
                                    ['required'],
                                    'ciudad de contacto'
                                ),
                            },
                            {
                                name: 'barrio_contacto',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                showTable: true,
                                dependency: 'ciudad_contacto',
                                options: [],
                                url: URL.BARRIOS.value,
                                validation: validationDefault(
                                    ['required'],
                                    'barrio de contacto'
                                ),
                            },
                            {
                                name: 'direccion',
                                label: 'Dirección',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.ADDRESS.required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.ADDRESS.maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.ADDRESS.minLength,
                                        },
                                    ],
                                    'dirección'
                                ),
                            },
                            {
                                name: 'referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                showTable: true,
                            },
                            {
                                name: 'telefono',
                                label: 'Teléfono',
                                disabled: false,
                                type: 'phone',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],
                                    'teléfono'
                                ),
                            },
                            {
                                name: 'celular',
                                label: 'Celular',
                                disabled: false,
                                type: 'celular',
                                col: 6,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.CELL_PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.CELL_PHONE
                                                .required,
                                        },
                                    ],
                                    'celular'
                                ),
                            },
                            {
                                name: 'correo_electronico',
                                label: 'Correo electrónico',
                                disabled: false,
                                type: 'email',
                                col: 6,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.EMAIL.regExp,
                                            mesagge:
                                                'El correo electrónico ingresado no es válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.EMAIL.required,
                                        },
                                    ],
                                    'correo electrónico'
                                ),
                            },
                            {
                                name: 'principal',
                                label: 'Dirección principal',
                                disabled: false,
                                type: 'select',
                                options: genericOptions.direccion_principal,
                                defaultValue: [],
                                col: 6,
                                showTable: true,
                            },
                        ],
                    },
                    {
                        name: 'Información del trabajo',
                        desc: '',
                        fields: [
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                    ],
                                    'empresa'
                                ),
                            },
                            {
                                name: 'trabajo_antiguedad',
                                label: 'Antigüedad (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],
                                    'antigüedad (meses)'
                                ),
                            },
                            {
                                name: 'trabajo_telefono',
                                label: 'Teléfono del trabajo',
                                disabled: false,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],
                                    'teléfono de la empresa'
                                ),
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Ingresos mensuales',
                                disabled: false,
                                type: 'price',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.INCOME.maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.INCOME.minLength,
                                        },
                                    ],
                                    'ingresos'
                                ),
                            },
                            {
                                name: 'otros_ingresos',
                                label: 'Otros ingresos',
                                disabled: false,
                                type: 'price',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.INCOME.maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.INCOME.minLength,
                                        },
                                    ],
                                    'ingresos'
                                ),
                            },
                            {
                                name: 'descripcion_otros_ingresos',
                                label: 'Descripción otros ingresos',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .DESCRIPTION_ACTIVITY.maxLength,
                                        },
                                    ],
                                    'descripción actividad económica'
                                ),
                            },
                            {
                                name: 'negocio_actividad',
                                label: 'Actividad económica',
                                disabled: false,
                                type: 'autocomplete',
                                col: 3,
                                options: [],
                                url: URL.ACTIVIDAD_ECONOMICA.value,
                            },
                            {
                                name: 'trabajo_ciudad',
                                label: 'Ciudad del trabajo',
                                disabled: false,
                                type: 'autocomplete-dependency',
                                showTable: true,
                                parentDependency: true,
                                childrenDependency: 'trabajo_barrio',
                                col: 6,
                                options: [],
                                url: URL.CIUDADES.value,
                            },
                            {
                                name: 'trabajo_barrio',
                                label: 'Barrio del trabajo',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                dependency: 'trabajo_ciudad',
                                trueDependency: 'ciudad',
                                url: URL.BARRIOS.value,
                            },
                            {
                                name: 'trabajo_direccion',
                                label: 'Dirección del trabajo',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                            },
                            {
                                name: 'trabajo_referencia_ubicacion',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .maxLength,
                                        },
                                    ],
                                    'referencia ubicación'
                                ),
                            },
                        ],
                    },
                ],
                defaultValues: {
                    tipo_de_documento: 'CC',
                    numero_identificacion: '123455556',
                    primer_nombre: 'test 1',
                    segundo_nombre: 'test 2',
                    primer_apellido: 'test ape1',
                    segundo_apellido: 'test ape2',
                    genero: 'H',
                    lugar_expedicion_documento: 1205,
                    fecha_expedicion_documento: '2020-08-30',
                    lugar_nacimiento: 1205,
                    fecha_nacimiento: '2020-08-30',
                    telefono_celular: '3105436525',
                    telefono_fijo: '5555555',

                    //info-trabajo
                    empresa: 'pruebas',
                    direccion_trabajo: 'vereda  aaaa',
                    codigo_postal: '76001',
                    descripcion_actividad_economica: 'test information',
                    antiguedad: 1,
                    telefono_empresa: '3215647',
                    ingresos: '200000',
                    actividad_economica: 'Venta de jugos',
                },
            },
          
            reassingUserRequest: {
                fields: [
                    {
                        name: 'usuario',
                        label: 'Ejecutivos',
                        disabled: false,
                        type: 'select',
                        col: 12,
                        options: [],
                        dependency: 'oficinas',
                        url: URL.EJECUTIVOS.value,
                        validation: validationDefault(['required'], 'usuario'),
                        //notSearchGlobals: true,
                    },
                    {
                        name: 'tipo_cambio_responsable',
                        disabled: false,
                        type: 'hidden',
                        col: 3,
                        value: 2,
                    },
                ],
            },
            reportsGeneral: {
                fields: [
                    {
                        name: 'tipo_reporte',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        url: '/globals/gestor_reportes/?rol=9',
                        validation: {
                            required: {
                                value: true,
                                message: 'El tipo reporte es obligatorio',
                            },
                        },
                        notSearchGlobals: true,
                    },
                    {
                        name: 'subproductos',
                        label: 'Subproductos',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        url: URL.SUBPRODUCTO.value,
                    },
                    {
                        name: 'oficinas',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'ejecutivo',
                        url: `/users/{0}/oficinas/`,
                        reduxParams: ['authUser.user'],
                        // validation: {
                        //     required: {
                        //         value: true,
                        //         message: 'La oficina es obligatorio',
                        //     },
                        // },
                    },
                    {
                        name: 'ejecutivos',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        //options: [],
                        dependency: 'oficinas',
                        url: URL.EJECUTIVOS.value,
                        notSearchGlobals: true,
                    },
                    {
                        name: 'fecha_desde',
                        label: 'Fecha desde',
                        disabled: false,
                        type: 'date',
                        col: 4,
                        validation: {
                            required: {
                                value: true,
                                message: 'La fecha desde es obligatoria',
                            },
                        },
                    },
                    {
                        name: 'fecha_hasta',
                        label: 'Fecha hasta',
                        disabled: false,
                        type: 'date',
                        col: 4,
                        validation: {
                            required: {
                                value: true,
                                message: 'La fecha hasta es obligatoria',
                            },
                        },
                    },
                    {
                        name: 'year',
                        label: 'Año',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: genericOptions.anios_report,
                        defaultValue: defaultYearReport(),
                        validation: {
                            required: {
                                value: true,
                                message: 'El Año es obligatorio',
                            },
                        },
                    },
                    {
                        name: 'month',
                        label: 'Mes',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: genericOptions.meses_report,
                        defaultValue: defaultMonthReport(),
                        validation: {
                            required: {
                                value: true,
                                message: 'El Mes es obligatorio',
                            },
                        },
                    },
                    {
                        name: 'producto',
                        label: 'Producto',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        url: URL.PRODUCTOS.value,
                        validation: {
                            required: {
                                value: true,
                                message: 'El campo producto es obligatorio',
                            },
                        },
                    },
                    {
                        name: 'estados',
                        label: 'Estados',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        url: '/globals/gmv_estados/',
                    },
                ],
            },
            reportTeamPerformance: {
                fields: [
                    {
                        name: 'groups',
                        label: 'Rol',
                        disabled: false,
                        type: 'hidden',
                        defaultValue: { value: 3, label: 'EJECUTIVO' },
                    },
                    {
                        name: 'oficinas',
                        label: 'Oficina',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        parentDependency: true,
                        childrenDependency: 'user',
                        url: `/users/{0}/oficinas/`,
                        reduxParams: ['authUser.user'],
                    },
                    {
                        name: 'user',
                        label: 'Usuario',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        prioritizeParent: true,
                        dependency: 'oficinas',
                        url: URL.EJECUTIVOS.value,
                        optionsExtra: {
                            value: 777889900,
                            label: 'CONSOLIDADO',
                        },
                        defaultValue: {
                            value: 777889900,
                            label: 'CONSOLIDADO',
                        },
                    },
                    {
                        name: 'type_group',
                        label: 'Tipo',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: [
                            { value: 0, label: 'AÑO - MES' },
                            { value: 1, label: 'MES - DIA' },
                        ],
                        defaultValue: { value: 0, label: 'AÑO - MES' },
                    },
                    {
                        name: 'year',
                        label: 'Año',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        options: genericOptions.anios_report,
                        defaultValue: defaultYearReport(),
                    },
                    {
                        name: 'month',
                        label: 'Mes',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        options: genericOptions.meses_report,
                    },
                ],
            },
            codebtorCredit: {
                permission: [
                    'codebtorCredit:list',
                    'codebtorCredit:edit',
                    'codebtorCredit:delete',
                ],
                fields: [],
            },
            codebtorInformation: {
                tittle: 'codeudor',
                fields: [
                    {
                        name: 'tipo_identificacion',
                        label: 'Tipo identificación',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                        testid: 'CodebtorTypeIdInput',
                    },
                    {
                        name: 'numero_identificacion',
                        label: 'Número identificación',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ID_NUMBER.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ID_NUMBER.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ID_NUMBER.minLength,
                                },
                            ],
                            'número de identificación'
                        ),
                        testid: 'CodebtorIdInput',
                    },
                    {
                        name: 'primer_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_NAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_NAME.minLength,
                                },
                            ],
                            'primer nombre'
                        ),
                        testid: 'CodebtorFirsNameInput',
                    },
                    {
                        name: 'segundo_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],
                            'segundo nombre'
                        ),
                        testid: 'CodebtorSecondNameInput',
                    },
                    {
                        name: 'primer_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_SURNAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_SURNAME.minLength,
                                },
                            ],
                            'primer apellido'
                        ),
                        testid: 'CodebtorLastFirsNameInput',
                    },
                    {
                        name: 'segundo_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],
                            'segundo apellido'
                        ),
                        testid: 'ClientSecondFirsNameInput',
                    },
                    {
                        name: 'celular',
                        label: 'Celular',
                        disabled: false,
                        type: 'celular',
                        col: 3,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.CELL_PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                                {
                                    type: 'required',
                                    value: PROPERTIES.CELL_PHONE.required,
                                },
                            ],
                            'celular'
                        ),
                        testid: 'CodebtorCellphoneInput',
                    },
                    {
                        name: 'tipo_relacion',
                        label: 'Tipo relación',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_relacion,
                        validation: validationDefault(
                            ['required'],
                            'tipo relación'
                        ),
                        testid: 'CodebtorRelationshipInput',
                    },
                ],
                socioEconomicCodebtor: {
                    fields: [
                        {
                            name: 'naturaleza_persona',
                            label: 'Tipo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.tipo_codeudor,
                            validation: validationDefault(
                                ['required'],
                                'naturaleza'
                            ),
                            isMulti: false,
                        },
                        {
                            name: 'estado_civil',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.estado_civil,
                            validation: validationDefault(
                                ['required'],
                                'estado civil'
                            ),
                        },
                        {
                            name: 'tipo_vivienda',
                            disabled: false,
                            type: 'select',
                            col: 6,
                            options: genericOptions.tipo_vivienda,
                            validation: validationDefaultNew(
                                [{ type: 'required', value: true }],
                                'tipo vivienda'
                            ),
                        },
                        {
                            name: 'estrato',
                            disabled: false,
                            type: 'integer',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'max',
                                        value: PROPERTIES.STRATUM.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.STRATUM.min,
                                    },
                                ],
                                'estrato'
                            ),
                        },
                        {
                            name: 'personas_a_cargo',
                            disabled: false,
                            type: 'integer',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.PEOPLE_IN_CHARGE.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.PEOPLE_IN_CHARGE.min,
                                    },
                                ],
                                'personas a cargo'
                            ),
                        },
                        {
                            name: 'numero_hijos',
                            label: 'Número hijos',
                            disabled: false,
                            type: 'integer',
                            col: 3,

                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.NUMBER_OF_CHILDREN
                                            .max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.NUMBER_OF_CHILDREN
                                            .min,
                                    },
                                ],
                                'número de hijos'
                            ),
                        },
                        {
                            name: 'escolaridad',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: genericOptions.escolaridad,
                            validation: validationDefault(
                                ['required'],
                                'escolaridad'
                            ),
                        },
                    ],
                    fieldsConditional: {
                        pI: [
                            {
                                name: 'negocio_actividad',
                                label: 'Actividad económica',
                                disabled: false,
                                type: 'autocomplete',
                                col: 6,
                                options: [],
                                url: URL.ACTIVIDAD_ECONOMICA.value,
                                validation: validationDefault(
                                    ['required'],
                                    'Actividad económica'
                                ),
                            },
                            {
                                name: 'negocio_descripcion',
                                label: 'Descripción actividad económica',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES
                                                .DESCRIPTION_ACTIVITY.required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .DESCRIPTION_ACTIVITY.maxLength,
                                        },
                                    ],
                                    'descripción actividad económica'
                                ),
                            },
                            {
                                name: 'trabajo_antiguedad',
                                label: 'Antigüedad  (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.ANTIQUITY
                                                .required,
                                        },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],
                                    'antigüedad residencia'
                                ),
                            },
                            {
                                name: 'trabajo_nombre',
                                label: 'Nombre del negocio',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                    ],
                                    'nombre del negocio'
                                ),
                            },
                            {
                                name: 'trabajo_direccion',
                                label: 'Dirección del negocio',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                validation: validationDefault(
                                    ['required'],
                                    'dirección del negocio'
                                ),
                            },
                            {
                                name: 'trabajo_telefono',
                                label: 'Teléfono del negocio',
                                disabled: false,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],
                                    'teléfono del negocio'
                                ),
                            },
                            {
                                name: 'trabajo_celular',
                                label: 'Celular',
                                disabled: false,
                                type: 'celular',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.CELL_PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.CELL_PHONE
                                                .required,
                                        },
                                    ],
                                    'celular'
                                ),
                            },
                            {
                                name: 'negocio_liquidez',
                                label: 'Liquidez',
                                disabled: false,
                                type: 'price',
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'liquidez'
                                ),
                            },
                        ],
                        pE: [
                            // EMPLEADO
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                    ],
                                    'empresa'
                                ),
                            },
                            {
                                name: 'empresa_contrato',
                                label: 'Contrato',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_contrato_codeudor,
                                validation: validationDefault(
                                    ['required'],
                                    'contrato'
                                ),
                            },
                            {
                                name: 'trabajo_cargo',
                                label: 'Cargo',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.JOB_POSITION
                                                .required,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .maxLength,
                                        },
                                    ],
                                    'cargo'
                                ),
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Salario',
                                disabled: false,
                                type: 'price',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'salario'
                                ),
                            },
                            {
                                name: 'trabajo_direccion',
                                label: 'Dirección empresa',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                validation: validationDefault(
                                    ['required'],
                                    'dirección empresa'
                                ),
                            },
                            {
                                name: 'trabajo_telefono',
                                label: 'Teléfono empresa',
                                disabled: false,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],
                                    'teléfono de la empresa'
                                ),
                            },
                            {
                                name: 'trabajo_celular',
                                label: 'Celular',
                                disabled: false,
                                type: 'celular',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.CELL_PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.CELL_PHONE
                                                .required,
                                        },
                                    ],
                                    'celular'
                                ),
                            },
                            {
                                name: 'trabajo_antiguedad',
                                label: 'Antigüedad empresa (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],
                                    'antigüedad empresa'
                                ),
                            },
                        ],
                        pP: [
                            // PENSIONADO
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                    ],
                                    'empresa'
                                ),
                            },
                            {
                                name: 'empresa_contrato',
                                label: 'Contrato',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_contrato_codeudor,
                                validation: validationDefault(
                                    ['required'],
                                    'contrato'
                                ),
                            },
                            {
                                name: 'trabajo_cargo',
                                label: 'Cargo',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.JOB_POSITION
                                                .required,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .maxLength,
                                        },
                                    ],
                                    'cargo'
                                ),
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Salario',
                                disabled: false,
                                type: 'price',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'salario'
                                ),
                            },
                            {
                                name: 'trabajo_direccion',
                                label: 'Dirección empresa',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                validation: validationDefault(
                                    ['required'],
                                    'dirección empresa'
                                ),
                            },
                            {
                                name: 'trabajo_telefono',
                                label: 'Teléfono empresa',
                                disabled: false,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],
                                    'teléfono de la empresa'
                                ),
                            },
                            {
                                name: 'trabajo_celular',
                                label: 'Celular',
                                disabled: false,
                                type: 'celular',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.CELL_PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                        {
                                            type: 'required',
                                            value: PROPERTIES.CELL_PHONE
                                                .required,
                                        },
                                    ],
                                    'celular'
                                ),
                            },
                            {
                                name: 'trabajo_antiguedad',
                                label: 'Antigüedad empresa (meses)',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.ANTIQUITY.max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.ANTIQUITY.min,
                                        },
                                    ],
                                    'antigüedad empresa'
                                ),
                            },
                        ],
                        pFR: [
                            // FINCA RAIZ
                            {
                                name: 'trabajo_cargo',
                                label: 'Ocupación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.JOB_POSITION
                                                .required,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .maxLength,
                                        },
                                    ],
                                    'Ocupación'
                                ),
                            },
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                    ],
                                    'empresa'
                                ),
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Salario',
                                disabled: false,
                                type: 'price',
                                col: 3,
                            },
                        ],
                        pFS: [
                            // FIRMA SOLIDARIA
                            {
                                name: 'trabajo_cargo',
                                label: 'Ocupación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.JOB_POSITION
                                                .required,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_POSITION
                                                .maxLength,
                                        },
                                    ],
                                    'Ocupación'
                                ),
                            },
                            {
                                name: 'trabajo_nombre',
                                label: 'Empresa',
                                disabled: false,
                                type: 'string',
                                col: 3,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                    ],
                                    'empresa'
                                ),
                            },
                            {
                                name: 'empresa_salario',
                                label: 'Salario',
                                disabled: false,
                                type: 'price',
                                col: 3,
                            },
                        ],
                    },
                },
                contactCodebtor: {
                    fields: [
                        {
                            name: 'ciudad_contacto',
                            label: 'Ciudad',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 6,
                            showTable: true,
                            options: [],
                            parentDependency: true,
                            childrenDependency: 'barrio_contacto',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad de contacto'
                            ),
                        },
                        {
                            name: 'barrio_contacto',
                            disabled: false,
                            type: 'select',
                            col: 6,
                            showTable: true,
                            dependency: 'ciudad_contacto',
                            options: [],
                            url: URL.BARRIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'barrio de contacto'
                            ),
                        },
                        {
                            name: 'direccion',
                            label: 'Dirección',
                            disabled: false,
                            type: 'addressComplement',
                            staticCol: 12,
                            showTable: true,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'required',
                                        value: PROPERTIES.ADDRESS.required,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.ADDRESS.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.ADDRESS.minLength,
                                    },
                                ],
                                'dirección'
                            ),
                        },
                        {
                            name: 'referencia_ubicacion',
                            label: 'Referencia ubicación',
                            disabled: false,
                            type: 'string',
                            col: 6,
                            showTable: true,
                        },
                        {
                            name: 'telefono',
                            label: 'Teléfono',
                            disabled: false,
                            type: 'phone',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'pattern',
                                        value: PROPERTIES.PHONE.regExp,
                                        mesagge:
                                            'El número ingresado no es un número válido',
                                    },
                                ],
                                'teléfono'
                            ),
                        },
                        {
                            name: 'celular',
                            label: 'Celular',
                            disabled: false,
                            type: 'celular',
                            col: 3,
                            showTable: true,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'pattern',
                                        value: PROPERTIES.CELL_PHONE.regExp,
                                        mesagge:
                                            'El número ingresado no es un número válido',
                                    },
                                    {
                                        type: 'required',
                                        value: PROPERTIES.CELL_PHONE.required,
                                    },
                                ],
                                'celular'
                            ),
                        },
                        {
                            name: 'correo_electronico',
                            label: 'Correo electrónico',
                            disabled: false,
                            type: 'email',
                            col: 6,
                            showTable: true,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'pattern',
                                        value: PROPERTIES.EMAIL.regExp,
                                        mesagge:
                                            'El correo electrónico ingresado no es válido',
                                    },
                                    {
                                        type: 'required',
                                        value: PROPERTIES.EMAIL.required,
                                    },
                                ],
                                'correo electrónico'
                            ),
                        },
                        {
                            name: 'principal',
                            label: 'Principal',
                            disabled: false,
                            type: 'select',
                            options: genericOptions.direccion_principal,
                            defaultValue: [],
                            col: 6,
                            showTable: true,
                        },
                    ],
                },
                codebtorConyuge: {
                    fields: [
                        {
                            name: 'Información básica',
                            desc: '',
                            fields: [
                                {
                                    name: 'tipo_identificacion',
                                    label: 'Tipo identificación',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    options: genericOptions.tipo_de_documento,
                                    validation: validationDefault(
                                        ['required'],
                                        'tipo identificación'
                                    ),
                                },
                                {
                                    name: 'numero_identificacion',
                                    label: 'Número identificación',
                                    disabled: false,
                                    type: 'integer',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'required',
                                                value: PROPERTIES.ID_NUMBER
                                                    .required,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.ID_NUMBER
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.ID_NUMBER
                                                    .minLength,
                                            },
                                        ],
                                        'número de identificación'
                                    ),
                                },
                                {
                                    name: 'primer_nombre',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'required',
                                                value: PROPERTIES.FIRST_NAME
                                                    .required,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.FIRST_NAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.FIRST_NAME
                                                    .minLength,
                                            },
                                        ],
                                        'primer nombre'
                                    ),
                                },
                                {
                                    name: 'segundo_nombre',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.SECOND_NAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.SECOND_NAME
                                                    .minLength,
                                            },
                                        ],
                                        'segundo nombre'
                                    ),
                                },
                                {
                                    name: 'primer_apellido',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'required',
                                                value: PROPERTIES.FIRST_SURNAME
                                                    .required,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.FIRST_SURNAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.FIRST_SURNAME
                                                    .minLength,
                                            },
                                        ],
                                        'primer apellido'
                                    ),
                                },
                                {
                                    name: 'segundo_apellido',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.SECOND_SURNAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.SECOND_SURNAME
                                                    .minLength,
                                            },
                                        ],
                                        'segundo nombre'
                                    ),
                                },
                                {
                                    name: 'genero',
                                    label: 'Género',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    options: genericOptions.genero,
                                    validation: validationDefault(
                                        ['required'],
                                        'genero'
                                    ),
                                },
                                {
                                    name: 'lugar_nacimiento',
                                    disabled: false,
                                    type: 'autocomplete',
                                    col: 3,
                                    options: [],
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'lugar de nacimiento'
                                    ),
                                },
                                {
                                    name: 'fecha_nacimiento',
                                    disabled: false,
                                    type: 'date',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'fecha de nacimiento'
                                    ),
                                },
                                {
                                    name: 'tipo_relacion',
                                    label: 'Tipo relación',
                                    disabled: false,
                                    type: 'hidden',
                                    col: 3,
                                    value: 2,
                                },
                            ],
                            defaultValues: {
                                tipo_de_documento: 'CC',
                                numero_identificacion: Math.floor(
                                    randomFloat(0, 1) * 10000
                                ),
                                primer_nombre: 'test 1',
                                segundo_nombre: 'test 2',
                                primer_apellido: 'test ape1',
                                segundo_apellido: 'test ape2',
                                genero: 'H',
                                lugar_expedicion_documento: 1205,
                                fecha_expedicion_documento: '2020-08-30',
                                lugar_nacimiento: 1205,
                                fecha_nacimiento: '2020-08-30',
                                telefono: '3102344556',
                                //info-trabajo
                                estado_civil: 'S',
                                estrato: 1,
                                ciuu: 10,
                                descripcion_actividad_economica:
                                    'test information',
                                antiguedad_residencia: 1,
                                personas_a_cargo: 1,
                                numero_hijos: 1,
                                escolaridad: 'PO',
                                naturaleza: 'I',
                            },
                        },
                        {
                            name: 'Información de contacto',
                            desc: '',
                            fields: [
                                {
                                    name: 'ciudad_contacto',
                                    label: 'Ciudad',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 6,
                                    showTable: true,
                                    options: [],
                                    parentDependency: true,
                                    childrenDependency: 'barrio_contacto',
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'ciudad de contacto'
                                    ),
                                },
                                {
                                    name: 'barrio_contacto',
                                    disabled: false,
                                    type: 'select',
                                    col: 6,
                                    showTable: true,
                                    dependency: 'ciudad_contacto',
                                    options: [],
                                    url: URL.BARRIOS.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'barrio de contacto'
                                    ),
                                },
                                {
                                    name: 'direccion',
                                    label: 'Dirección',
                                    disabled: false,
                                    type: 'addressComplement',
                                    staticCol: 12,
                                    showTable: true,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'required',
                                                value: PROPERTIES.ADDRESS
                                                    .required,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.ADDRESS
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.ADDRESS
                                                    .minLength,
                                            },
                                        ],
                                        'dirección'
                                    ),
                                },
                                {
                                    name: 'referencia_ubicacion',
                                    label: 'Referencia ubicación',
                                    disabled: false,
                                    type: 'string',
                                    col: 6,
                                    showTable: true,
                                },
                                {
                                    name: 'telefono',
                                    label: 'Teléfono',
                                    disabled: false,
                                    type: 'phone',
                                    col: 6,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.PHONE.regExp,
                                                mesagge:
                                                    'El número ingresado no es un número válido',
                                            },
                                        ],
                                        'teléfono'
                                    ),
                                },
                                {
                                    name: 'celular',
                                    label: 'Celular',
                                    disabled: false,
                                    type: 'celular',
                                    col: 6,
                                    showTable: true,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.CELL_PHONE
                                                    .regExp,
                                                mesagge:
                                                    'El número ingresado no es un número válido',
                                            },
                                            {
                                                type: 'required',
                                                value: PROPERTIES.CELL_PHONE
                                                    .required,
                                            },
                                        ],
                                        'celular'
                                    ),
                                },
                                {
                                    name: 'correo_electronico',
                                    label: 'Correo electrónico',
                                    disabled: false,
                                    type: 'email',
                                    col: 6,
                                    showTable: true,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.EMAIL.regExp,
                                                mesagge:
                                                    'El correo electrónico ingresado no es válido',
                                            },
                                            {
                                                type: 'required',
                                                value: PROPERTIES.EMAIL
                                                    .required,
                                            },
                                        ],
                                        'correo electrónico'
                                    ),
                                },
                            ],
                        },
                        {
                            name: 'Información del trabajo',
                            desc: '',
                            fields: [
                                {
                                    name: 'trabajo_nombre',
                                    label: 'Empresa',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.JOB_NAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.JOB_NAME
                                                    .minLength,
                                            },
                                        ],
                                        'empresa'
                                    ),
                                },
                                {
                                    name: 'trabajo_direccion',
                                    label: 'Dirección del trabajo',
                                    disabled: false,
                                    type: 'addressComplement',
                                    staticCol: 12,
                                },
                                {
                                    name: 'trabajo_ciudad',
                                    label: 'Ciudad de trabajo',
                                    disabled: false,
                                    type: 'autocomplete',
                                    col: 3,
                                    options: [],
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'trabajo_antiguedad',
                                    label: 'Antigüedad (meses)',
                                    disabled: false,
                                    type: 'integer',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'max',
                                                value: PROPERTIES.ANTIQUITY.max,
                                            },
                                            {
                                                type: 'min',
                                                value: PROPERTIES.ANTIQUITY.min,
                                            },
                                        ],
                                        'antigüedad (meses)'
                                    ),
                                },
                                {
                                    name: 'trabajo_telefono',
                                    label: 'Teléfono de la empresa',
                                    disabled: false,
                                    type: 'phone',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.PHONE.regExp,
                                                mesagge:
                                                    'El número ingresado no es un número válido',
                                            },
                                        ],
                                        'teléfono de la empresa'
                                    ),
                                },
                                {
                                    name: 'empresa_salario',
                                    label: 'Ingresos',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.INCOME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.INCOME
                                                    .minLength,
                                            },
                                        ],
                                        'ingresos'
                                    ),
                                },
                                {
                                    name: 'negocio_actividad',
                                    label: 'Actividad económica',
                                    disabled: false,
                                    type: 'autocomplete',
                                    col: 3,
                                    options: [],
                                    url: URL.ACTIVIDAD_ECONOMICA.value,
                                },
                            ],
                        },
                    ],
                },
            },
            heritageCodebtor: {
                fields: [
                    {
                        name: 'Presupuesto familiar',
                        desc: '...',
                        fields: [
                            {
                                name: 'ingreso_principal',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'ingreso_conyuge',
                                label: 'Ingresos cónyuge',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'otros_ingresos',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'gastos_familiar',
                                label: 'Gasto familiar',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'obligaciones',
                                label: 'Obligaciones / cuotas',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'excedente',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                        ],
                    },
                    {
                        name: 'Presupuesto empresarial',
                        desc: '...',
                        fields: [
                            {
                                name: 'total_activos',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'total_pasivos',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                            {
                                name: 'total_patrimonio',
                                disabled: true,
                                type: 'price',
                                col: 4,
                            },
                        ],
                    },
                ],
                realState: [
                    {
                        name: 'Bienes raíces',
                        desc: '...',
                        fields: [
                            {
                                name: 'tipo_vivienda',
                                label: 'Tipo de bien raíz',
                                disabled: true,
                                type: 'select',
                                options: genericOptions.tipo_de_bien_raiz,
                                col: 6,
                            },
                            {
                                name: 'direccion_bien_raiz',
                                label: 'Dirección',
                                disabled: true,
                                type: 'addressComplement',
                                staticCol: 12,
                                showTable: true,
                            },
                            {
                                name: 'valor_bien_raiz',
                                label: 'Valor comercial',
                                disabled: true,
                                type: 'price',
                                col: 6,
                            },
                        ],
                    },
                ],
                ownVehicle: [
                    {
                        name: 'Vehículo',
                        desc: '...',
                        fields: [
                            {
                                name: 'marca',
                                disabled: true,
                                type: 'select',
                                col: 6,
                                url: URL.MARCAS.value,
                            },
                            {
                                name: 'placa',
                                disabled: true,
                                type: 'string',
                                col: 6,
                            },
                            {
                                name: 'modelo',
                                disabled: true,
                                type: 'integer',
                                col: 6,
                            },
                            {
                                name: 'valor_vehiculo',
                                label: 'Valor comercial',
                                disabled: true,
                                type: 'price',
                                col: 6,
                            },
                        ],
                    },
                ],
            },
            documentsClient: {
                permisions: ['documentsClient:list', 'documentsClient:edit'],
                fields: [
                    {
                        name: 'persona_tipo_documento',
                        label: 'Tipo documento',
                        disabled: false,
                        type: 'select',
                        col: 5,
                        url: '/personas/tipo_documentos/?roles=9',
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                    },
                    {
                        name: 'documento',
                        disabled: false,
                        type: 'file',
                        col: 5,
                        validation: validationDefault(
                            ['required'],
                            'documento'
                        ),
                    },
                ],
            },
            filterDataTableWarranty: {
                permisions: ['filterDataTableWarranty'],
                fields: [
                    {
                        name: 'oficinas',
                        disabled: false,
                        type: 'select-multiple',
                        col: 6,
                        options: [],
                        url: `/users/{0}/oficinas/`,
                        reduxParams: ['authUser.user'],
                        notSearchGlobals: true,
                    },
                    {
                        name: 'productos',
                        label: 'Productos',
                        disabled: false,
                        type: 'select-multiple',
                        col: 6,
                        //options: [],
                        url: '/globals/productos/?id=4,6,1',
                        notSearchGlobals: true,
                    },
                ],
            },
            documentsWarranty: {
                permisions: [
                    'documentsWarranty:list',
                    'documentsWarranty:edit',
                ],
                fields: [
                    {
                        name: 'tipo_documento',
                        disabled: false,
                        type: 'select',
                        col: 5,
                        url: '/globals/gmv_tipo_documentos/?roles=9&is_active=true&tramite_voluntario={0}&estado={1}',
                        reduxParams: [
                            'warranty.tramite_voluntario_String',
                            'warranty.estado.value',
                        ],
                        options: [],
                        showTable: true,
                        notSearchGlobals: true,
                    },
                    {
                        name: 'documento',
                        disabled: false,
                        type: 'file',
                        col: 5,
                    },
                ],
            },
            observationWarranty: {
                permisions: ['observationWarranty:list'],
                fields: [
                    {
                        className: 'input-observacion',
                        name: 'observacion',
                        label: 'Observación',
                        disabled: false,
                        type: 'string',
                        rows: 1,
                        typeColumn: 2,
                        col: 12,
                        showTable: true,
                        staticCol: 12,
                        validation: validationDefault(
                            ['required'],
                            'observación'
                        ),
                    },
                ],
            },
            InformationWarrantyVehicle: {
                permisions: [
                    'InformationWarrantyVehicle:list',
                    'InformationWarrantyVehicle:edit',
                ],
                fieldsUbicacion: [
                    {
                        name: 'ciudad_ubicacion',
                        label: 'Ciudad',
                        disabled: false,
                        type: 'autocomplete-dependency',
                        col: 6,
                        showTable: true,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'barrio_ubicacion',
                        url: URL.CIUDADES.value,
                    },
                    {
                        name: 'barrio_ubicacion',
                        label: 'Barrio ubicación',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        dependency: 'ciudad_ubicacion',
                        trueDependency: 'ciudad',
                        notSearchGlobals: true,
                        url: URL.BARRIOS.value,
                    },
                    {
                        name: 'direccion_ubicacion',
                        label: 'Dirección',
                        disabled: false,
                        type: 'addressComplement',
                        staticCol: 12,
                        showTable: true,
                    },
                    {
                        name: 'referencia_ubicacion',
                        label: 'Referencia ubicación',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        showTable: true,
                    },
                ],
                fieldsEstado: [
                    {
                        name: 'peritaje',
                        label: 'Peritaje',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        options: [
                            { value: 'true', label: 'SI' },
                            { value: 'false', label: 'NO' },
                        ],
                    },
                    {
                        name: 'kilometraje',
                        label: 'Kilometraje',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        showTable: true,
                    },
                    {
                        name: 'gps',
                        label: 'GPS',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        options: [
                            { value: 'true', label: 'SI' },
                            { value: 'false', label: 'NO' },
                        ],
                    },
                    {
                        name: 'tipo_propietarios_vehiculo',
                        label: 'Propietario vehículo',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        url: `/globals/gmv_tipo_propietarios_vehiculos/?is_active=true`,
                    },
                    {
                        name: 'valor_fasecolda_vehiculo',
                        label: 'Valor fasecolda',
                        disabled: false,
                        type: 'price',
                        col: 6,
                        showTable: true,
                    },
                    {
                        name: 'valor_peritaje_vehiculo',
                        label: 'Valor peritaje',
                        disabled: false,
                        type: 'price',
                        col: 6,
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'Valor peritaje'
                        ),
                    },
                ],
            },
            ContactsWarranty: {
                permisions: [
                    'ContactsWarranty:list',
                    'ContactsWarranty:edit',
                    'ContactsWarranty:deleteButton',
                ],
                fields: [
                    {
                        name: 'nombre',
                        label: 'Nombre',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        showTable: true,
                        validation: validationDefault(['required'], 'nombre'),
                    },
                    {
                        name: 'celular',
                        label: 'Número telefónico',
                        disabled: false,
                        showTable: true,
                        type: 'celular',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'número telefónico'
                        ),
                    },
                    {
                        name: 'tipo',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        options: [
                            { value: 'ENCARGADO', label: 'ENCARGADO' },
                            { value: 'OTRO', label: 'OTRO' },
                        ],
                        validation: validationDefault(['required'], 'tipo'),
                    },
                    {
                        className: 'input-observacion',
                        name: 'observacion',
                        label: 'Observación',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        showTable: true,
                    },
                ],
            },
            InformationWarranty: {
                permisions: [
                    'InformationWarranty:list',
                    'InformationWarranty:edit',
                ],
                fields: [
                    {
                        name: 'solicitud.id',
                        label: 'Solicitud de crédito',
                        disabled: true,
                        type: 'string',
                        col: 4,
                        showTable: true,
                    },
                    {
                        name: 'solicitud.oficina',
                        label: 'Oficina',
                        disabled: true,
                        showTable: true,
                        type: 'select',
                        options: [],
                        col: 4,
                    },
                    {
                        name: 'solicitud.codigo_gyg',
                        label: 'Num crédito',
                        disabled: true,
                        type: 'string',
                        col: 4,
                        showTable: true,
                    },
                    {
                        name: 'solicitud.dias_mora',
                        label: 'Días mora',
                        disabled: true,
                        type: 'string',
                        col: 4,
                        showTable: true,
                    },
                    {
                        name: 'solicitud.saldo_prestamo',
                        label: 'Saldo',
                        disabled: true,
                        type: 'price',
                        col: 4,
                        showTable: true,
                    },
                ],
            },
            FinancialEvaluationWarranty: {
                permisions: [
                    'FinancialEvaluationWarranty:list',
                    'FinancialEvaluationWarranty:edit',
                ],
                fields: [
                    {
                        name: 'valor_acuerdo_venta_vehiculo',
                        label: 'Valor acuerdo venta',
                        disabled: false,
                        type: 'price',
                        col: 6,
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'Valor acuerdo'
                        ),
                    },
                    {
                        name: 'gastos_vehiculo',
                        label: 'Gastos vehículo',
                        disabled: true,
                        type: 'price',
                        col: 6,
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'Gastos vehiculo'
                        ),
                    },
                    {
                        name: 'valor_venta_vehiculo',
                        label: 'Valor venta vehículo',
                        disabled: true,
                        type: 'price',
                        col: 6,
                        showTable: true,
                    },
                ],
            },
            filterDataTableFinancialSolutions: {
                permisions: ['filterDataTableFinancialSolutions'],
                fields: [
                    {
                        name: 'oficinas',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        options: [],
                        url: `/users/{0}/oficinas/`,
                        reduxParams: ['authUser.user'],
                    },
                    {
                        name: 'subproductos',
                        label: 'Subproductos',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        //options: [],
                        url: '/globals/subproducto/',
                        notSearchGlobals: true,
                    },
                    {
                        name: 'tipo_solucion_financiera',
                        label: 'Tipo',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        url: '/globals/sf_tipo_soluciones_financieras/ ',
                        notSearchGlobals: true,
                    },
                ],
            },
            BillsWarranty: {
                permisions: ['BillsWarranty:list'],
                fields: [
                    {
                        name: 'tipo_gasto',
                        label: 'Tipo gasto',
                        disabled: true,
                        type: 'select',
                        col: 12,
                        staticCol: 12,
                        showTable: true,
                        url: '/globals/tipo_gastos_gmv/',
                        validation: validationDefault(
                            ['required'],
                            'Tipo gasto'
                        ),
                    },

                    {
                        name: 'valor',
                        label: 'Valor',
                        disabled: true,
                        type: 'price',
                        col: 12,
                        staticCol: 12,
                        showTable: true,
                        validation: validationDefault(['required'], 'Valor'),
                    },
                    {
                        name: 'observacion',
                        label: 'Observación',
                        disabled: true,
                        type: 'string',
                        col: 12,
                        showTable: true,
                        staticCol: 12,
                    },
                    {
                        name: 'documento',
                        label: 'Factura',
                        disabled: true,
                        type: 'file',
                        col: 12,
                        staticCol: 12,
                        showTable: true,
                        validation: validationDefault(['required'], 'Factura'),
                    },
                ],
            },
            runtPreRegistration: {
                fields: [
                    {
                        name: 'numero_identificacion',
                        label: 'Número identificación',
                        disabled: false,
                        type: 'autocomplete',
                        staticCol: 12,
                        options: [],
                        url: '/globals/solicitudes/?oficinas={0}&productos=1,6,4,8',
                        searchSecondParam: true,
                        reduxParams: ['authUser.userOffices'],
                        validation: validationDefault(
                            ['required'],
                            'Número de identificación'
                        ),
                    },
                    {
                        name: 'chasis_vehiculo',
                        label: 'Chasis',
                        disabled: false,
                        type: 'string',
                        staticCol: 12,
                        validation: validationDefault(['required'], 'chasis'),
                    },
                    {
                        name: 'documento_factura',
                        label: 'Factura',
                        disabled: false,
                        type: 'file',
                        staticCol: 12,
                    },
                ],
            },
        },
    },
};

export default Rules;
